{
  "imageUpload": {
    "preparing": "Preparing image…",
    "uploading": "Uploading image…",
    "retrying": "Retrying upload…",
    "failed": "The image could not be uploaded",
    "failedTooLarge": "The image is too large",
    "failedUnsupported": "Image format not supported",
    "failedNetwork": "Cannot reach the server",
    "failedPrepare": "The image could not be processed",
    "retry": "Retry",
    "pendingWarning": "{{count}} image(s) exist only in this browser and have not been saved to the server. They will be lost if you close or reload the page."
  },
  "super": {
    "title": "Administration",
    "issuesTitle": "Reports and ideas",
    "issuesSubtitle": "Review the issues and suggestions submitted by users",
    "brandsTab": "Brands",
    "brandsTitle": "Brands and distributors",
    "brandsSubtitle": "Who brings us each client and what they see when they log in"
  },
  "radiologyStyle": {
    "title": "Your radiology style",
    "description": "Create a list of preferences describing how you like your reports written. For example: \"I want all findings in bold\".",
    "menuLabel": "Your radiology style",
    "settingsTitle": "Your radiology style",
    "settingsDescription": "Define how you like your reports written with a list of personal preferences",
    "settingsText": "Create and edit your list of style preferences. For example: \"I want all findings in bold\".",
    "settingsButton": "Edit my style",
    "empty": "You haven't added any style preferences yet.",
    "placeholder": "E.g. I want all findings in bold",
    "addRule": "Add preference",
    "removeRule": "Remove preference",
    "saving": "Saving…",
    "saved": "Your radiology style was saved successfully",
    "saveError": "Your radiology style could not be saved",
    "limitHint": "Up to {{maxRules}} preferences of {{maxLength}} characters each.",
    "maxRulesReached": "You have reached the maximum of {{maxRules}} preferences",
    "ruleTooLong": "A preference exceeds {{maxLength}} characters: shorten it to save"
  },
  "common": {
    "welcome": "Welcome",
    "unknownModality": "Unknown modality",
    "unknownRegion": "Unknown region",
    "professionalTitleDefault": "Dr.",
    "login": "Login",
    "logout": "Logout",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "close": "Close",
    "search": "Search",
    "loading": "Loading...",
    "sending": "Sending...",
    "error": "Error",
    "success": "Success",
    "email": "Email",
    "password": "Password",
    "submit": "Submit",
    "back": "Back",
    "continue": "Continue",
    "next": "Next",
    "previous": "Previous",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "goHome": "Go home",
    "home": "Home",
    "myInsights": "My insights",
    "groupReports": "Work history",
    "createReport": "Create Report",
    "templates": "Templates",
    "accounts": "Accounts",
    "users": "Users",
    "issues": "Issues",
    "adminPanel": "Admin panel",
    "orgAdmin": "Organization",
    "configuration": "Settings",
    "parameters": "Parameters",
    "openMenu": "Open menu",
    "collapseMenu": "Collapse menu",
    "expandMenu": "Expand menu",
    "writeHere": "Write here...",
    "headingPlaceholder": "Heading",
    "selectButtonsToExport": "Select buttons to export",
    "exportSelection": "Export selection",
    "configureButtons": "Configure buttons to export",
    "searchPlaceholder": "Search...",
    "clearSelection": "Clear selection",
    "noResults": "No results found",
    "commands": "Commands",
    "insert": "Insert",
    "update": "Update",
    "generate": "Generate",
    "select": "Select",
    "dictate": "Dictate",
    "language": "Language",
    "showing": "Showing",
    "of": "of",
    "or": "or",
    "page": "Page",
    "item": "item",
    "items": "items",
    "copy": "Copy",
    "clear": "Clear",
    "share": "Share",
    "discard": "Discard",
    "deleting": "Deleting...",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "send": "Send",
    "pause": "Pause",
    "resume": "Resume",
    "showLaterality": "Show laterality",
    "hideLaterality": "Hide laterality",
    "laterality": {
      "left": "Left",
      "right": "Right",
      "both": "Bilateral"
    },
    "groups": "Groups"
  },
  "commandPalette": {
    "searchPlaceholder": "Type a command...",
    "results": "Results",
    "searching": "Searching...",
    "noTemplatesFound": "No templates found",
    "suggestions": "Suggestions",
    "createTemplate": "Create template",
    "startDictation": "Start dictation",
    "generateReport": "Generate report",
    "recentTemplates": "Recent templates",
    "errorLoadingTemplates": "Error loading templates",
    "errorSearching": "Error searching templates",
    "mustUseWithinProvider": "useCommandPalette must be used within CommandPaletteProvider"
  },
  "auth": {
    "welcomeHello": "Hello,",
    "welcomeBack": "Welcome",
    "launchSignInNeeded": "Your study is waiting. Sign in to continue.",
    "launchIdentityRefused": "We could not sign you in automatically: your user is not authorised on the installation the study was launched from. Ask your administrator to add you. In the meantime, you can sign in here.",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "loginTitle": "Login to Ainovis",
    "loginSubtitle": "Enter your credentials to access",
    "forgotPassword": "Forgot your password?",
    "rememberMe": "Remember me",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up",
    "alreadyHaveAccount": "Already have an account?",
    "signIn": "Sign in",
    "verifyEmail": "Verify email",
    "verifyEmailText": "We have sent a verification email to your email address",
    "resetPassword": "Reset password",
    "resetPasswordText": "Enter your new password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "sendResetLink": "Send reset link",
    "backToLogin": "Back to login",
    "googleLogin": "Continue with Google",
    "microsoftLogin": "Continue with Microsoft",
    "orLoginWith": "Or login with",
    "authenticatingMicrosoft": "Authenticating with Microsoft...",
    "processingAuth": "Processing authentication...",
    "resetPasswordTitle": "Reset password",
    "resetPasswordDescription": "Enter your new password",
    "resetting": "Resetting...",
    "resetPasswordButton": "Reset password",
    "invalidToken": "Invalid or expired token",
    "completeAllFields": "Please complete all fields",
    "passwordsDoNotMatch": "Passwords do not match",
    "passwordMinLength": "Password must be at least 6 characters",
    "passwordResetSuccess": "Password reset successfully",
    "enterButton": "Enter",
    "emailPlaceholder": "Email",
    "passwordPlaceholder": "Password",
    "completeCaptcha": "Please complete the captcha",
    "continueWith": "or continue with",
    "continueWithMicrosoft": "Continue with Microsoft",
    "forgotPasswordTitle": "Forgot your password?",
    "forgotPasswordDescription": "Don't worry, we'll send you instructions to reset it",
    "sendInstructions": "Send instructions",
    "emailSentTitle": "Email sent",
    "emailSentMessage": "We have sent an email to {{email}} with instructions to reset your password",
    "checkSpam": "If you don't receive the email in a few minutes, check your spam folder"
  },
  "notFound": {
    "title": "404",
    "subtitle": "Page not found",
    "message": "Sorry, the page you are looking for does not exist or has been moved"
  },
  "dashboard": {
    "title": "Dashboard",
    "reports": "Reports",
    "recentReports": "Your recent diagnostic reports",
    "createReport": "Create report",
    "viewAll": "View all",
    "statistics": "Statistics",
    "totalReports": "Total reports",
    "pendingReports": "Pending reports",
    "completedReports": "Completed reports"
  },
  "reports": {
    "deselectAll": "Deselect all",
    "allSelected": "All selected ({{count}})",
    "tapToSelectAll": "Select all",
    "selectedCountHint": "· {{count}} selected",
    "selectedCountHint_one": "· {{count}} selected",
    "selectedCountHint_other": "· {{count}} selected",
    "signReport": "Sign",
    "signedBy": "Signed by:",
    "licenseNumber": "License number",
    "sendBusy": "Wait for the current process to finish",
    "requestEdit": "Request edit access",
    "requestEditSent": "Request sent",
    "requestEditError": "Could not send the request. Please try again.",
    "editRequestToast": "{{name}} is requesting edit access.",
    "editRequestManage": "Manage",
    "editRequestSomeone": "A user",
    "title": "Reports",
    "newReport": "New report",
    "reportList": "Report list",
    "reportDetails": "Report details",
    "status": "Status",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "createdBy": "Created by",
    "draft": "Draft",
    "published": "Published",
    "archived": "Archived",
    "noReports": "No reports available",
    "deleteConfirm": "Are you sure you want to delete this report?",
    "studyDescription": "Study description",
    "studyDescriptionPlaceholder": "Enter the study description...",
    "reasonForRequestedProcedure": "Reason for request",
    "reportGeneration": "Generation",
    "automatic": "Automatic",
    "manual": "Manual",
    "automaticTooltip": "Generate the report automatically",
    "manualTooltip": "Generate the report from the selected template",
    "reportFormat": "Report type",
    "inside": "Inside",
    "first": "First",
    "insideTooltip": "Findings will be evenly distributed within the 'Findings' section",
    "firstTooltip": "Findings will be placed at the beginning of the 'Findings' section",
    "selectedTemplate": "Selected Template",
    "templateList": "Template List",
    "auto": "Auto",
    "automatic2": "Automatic",
    "enterDescription": "Please enter a study description",
    "reportCopied": "Report copied successfully",
    "reportGenerated": "Report generated successfully",
    "reportSaved": "Report saved successfully",
    "noReportToSave": "No generated report to save",
    "missingReportInfo": "Missing report information",
    "timeoutError": "Generation took too long. Try with a shorter description",
    "generateButton": "Generate report",
    "generating": "Generating...",
    "thinking": "Thinking...",
    "saveButton": "Save report",
    "saving": "Saving...",
    "generatingMessage": "Generating report...",
    "savingMessage": "Saving report...",
    "editorPlaceholder": "The generated report will appear here...",
    "activateDictation": "Activate voice dictation",
    "holdMicSendHint": "Release to send · Esc to cancel",
    "holdMicCancelHint": "Release to cancel",
    "keepAllContent": "Keep all marked content",
    "keepContentDesc": "Keep marked content (merge without deleting)",
    "deleteAllContent": "Delete all marked content",
    "keepOriginal": "Keep original text",
    "keepOriginalDesc": "Keep original text (discard changes)",
    "applyUpdates": "Apply all updates",
    "generateReport": "Generate report",
    "basedOnRecentActivity": "Based on your recent activity",
    "aiDisclaimer": "Ainovis can make mistakes. Consider verifying important information",
    "reportContent": "Report parameters",
    "continueWithBaseTemplate": "Continue with base template",
    "blocksDetected": "Blocks detected",
    "selectBlockHint": "Select a block or continue with the base template",
    "continueWithNormalTemplate": "Continue without blocks",
    "referenceSelected": "Reference selected ✓",
    "blockSelected": "Block selected ✓",
    "blockSkipped": "Continuing without block ✓",
    "description": "Descriptive",
    "detectedProcedures": "Detected procedures",
    "noProceduresDetected": "No procedures detected",
    "detectedLaterality": "Detected laterality",
    "noLateralityFound": "No laterality found",
    "searchLaterality": "Align laterality",
    "lateralityUpdated": "Laterality updated",
    "errorSearchingLaterality": "Error detecting laterality",
    "findingsFirst": "Findings at the beginning",
    "findingsInside": "Findings within the text",
    "welcome": "Welcome {{title}} {{surname}}",
    "searchTemplate": "Search template...",
    "loadingTemplate": "Loading template...",
    "multipleReferencesDetected": "Multiple references detected",
    "selectReferenceHint": "Select an option to continue with the generation",
    "generateManualReport": "Generate manual report",
    "blankCanvas": "Blank canvas",
    "createTemplate": "Create template",
    "viewPowerBI": "View Statistics",
    "uploadAudio": "Batch audio processing",
    "activitySummary": "Activity summary",
    "viewMoreStats": "View more statistics",
    "noTemplatesFound": "No templates found",
    "errorCreatingBlankCanvas": "Error creating blank canvas",
    "manualModePlaceholder": "Type the template you want to use",
    "navigate": "navigate",
    "select": "select",
    "close": "close",
    "loadingTemplates": "Loading templates...",
    "searchPlaceholder": "Search report...",
    "reportsHistorySidebarTitle": "Report history",
    "versionHistoryPreviewStamp": "Previous version",
    "reportsHistorySidebarTitleSaved": "Sent reports",
    "reportsHistoryPreviewStamp": "Sent report",
    "reportsHistorySidebarClose": "Close history panel",
    "reportsHistoryLoading": "Loading…",
    "reportsHistoryError": "Could not load the history",
    "reportsHistoryNoResults": "No results",
    "reportsHistoryDraftsEmpty": "You have no drafts",
    "reportsHistorySavedEmpty": "You have no sent reports",
    "reportsHistoryUntitled": "Untitled",
    "reportsHistoryTabDrafts": "Drafts",
    "reportsHistoryTabSaved": "Sent",
    "createReport": "Create report",
    "currentStatus": "Current status",
    "pendingReview": "Reports pending review",
    "savedToday": "Reports saved today",
    "draftReports": "Draft reports",
    "recentReports": "Recent diagnostic reports",
    "drafts": "Drafts",
    "sent": "Sent",
    "saved": "Sent",
    "sharedWithMe": "Shared with me",
    "ownedByMe": "I'm the owner",
    "noOwnedDrafts": "No drafts you own",
    "countOwned": "{{count}} owned",
    "workHistoryTitle": "Work history",
    "viewGroupWorkHistory": "View group work history",
    "countDrafts": "{{count}} drafts",
    "countBatches": "{{count}} batches",
    "countSent": "{{count}} sent",
    "countShared": "{{count}} shared",
    "diagnosis": "Conclusion",
    "versions": "Versions",
    "version": "version",
    "lastUpdate": "Last update",
    "actions": "Actions",
    "noDrafts": "No drafts",
    "noSharedDrafts": "No reports shared with you",
    "noDiagnosis": "(No diagnosis)",
    "loadingVersions": "Loading versions...",
    "owner": "Owner",
    "modalities": "Modalities",
    "procedure": "Procedure",
    "procedures": "Procedures",
    "time": "Time",
    "draftVersionsInfo": "This draft has {{count}} saved version(s)",
    "report": "report",
    "reports": "reports",
    "yourPerformance": "Your performance",
    "last7Days": "Last 7 days",
    "thisWeek": "This week",
    "thisMonth": "This month",
    "today": "Today",
    "yesterday": "Yesterday",
    "last30Days": "Last 30 days",
    "older": "Older",
    "totalReports": "Total",
    "deleteDraftTitle": "Delete draft",
    "leaveDraft": "Leave draft",
    "leaveDraftTitle": "Leave draft",
    "leaveDraftConfirm": "Leave",
    "leaveDraftMessage": "You will lose access to this shared draft. The owner can share it with you again.",
    "deleteReportTitle": "Delete report",
    "deleteDraftMessage": "Are you sure you want to delete this draft and all its versions? This action cannot be undone.",
    "deleteReportMessage": "Are you sure you want to delete this saved report? This action cannot be undone.",
    "deleteBatchTitle": "Delete batch",
    "deleteBatchMessage": "Are you sure you want to delete this batch and all its studies? This action cannot be undone.",
    "errorLoadingReport": "Error loading the report",
    "noContentToCopy": "No content to copy",
    "contentCopied": "Content copied to clipboard",
    "errorCopying": "Error copying content",
    "errorPreSaveValidation": "Error validating before saving",
    "preSaveInconsistencies": "Inconsistencies detected",
    "preSaveVersions": "Multiple versions",
    "preSaveVersionsMsg": "Only the current version will be saved and the remaining {{count}} will be discarded.",
    "errorSavingReport": "Error saving the report",
    "errorSavingDraft": "Error saving the draft",
    "draftDeleted": "Draft deleted successfully",
    "errorDeletingDraft": "Error deleting the draft",
    "emptyTechnique": "The technique is empty",
    "proceduresFound": "Procedures updated",
    "errorSearchingProcedures": "Error searching procedures",
    "blankVersionCreated": "Blank canvas created",
    "errorCreatingBlankVersion": "Error creating blank canvas",
    "loadingReport": "Loading report...",
    "deletingMessage": "Deleting draft...",
    "searchingProcedures": "Searching procedures...",
    "searchingLaterality": "Detecting laterality...",
    "hideProcedures": "Hide procedures",
    "searchProcedures": "Search procedures",
    "showProcedures": "Show procedures",
    "confirmDeleteDraft": "Are you sure you want to delete this draft? This action cannot be undone.",
    "inconsistency": "Inconsistency",
    "show": "Show",
    "preSaveTitle": "Before saving",
    "preSaveSubtitle": "The following warnings have been detected:",
    "confirmSave": "Send anyway",
    "unsavedChanges": "Unsaved changes",
    "unsavedChangesMessage": "\"{{title}}\" has unsaved changes. Discard changes?",
    "maxVersionsReached": "Maximum reports reached",
    "settings": "Settings",
    "reportType": "Report type",
    "noTemplateSelected": "Automatic detection",
    "useAnotherTemplate": "Use another template",
    "change": "Change",
    "changeTemplate": "Change template",
    "backToAutoDetection": "Back to automatic detection",
    "autoDetection": "Automatic detection",
    "noDescription": "No description",
    "resume": "Resume",
    "pause": "Pause",
    "process": "Process",
    "processingAudio": "Processing audio...",
    "analyzingVoice": "Analyzing your voice...",
    "transcribingAudio": "Transcribing audio...",
    "interpretingCommands": "Interpreting commands...",
    "preparingResult": "Preparing result...",
    "analyzingText": "Analyzing your text...",
    "understandingIntent": "Understanding intent...",
    "readingContext": "Reading the context...",
    "identifyingSections": "Identifying sections...",
    "writing": "Writing...",
    "fillingReport": "Filling in the report...",
    "writingSections": "Writing sections...",
    "addingFindings": "Adding findings...",
    "refiningContent": "Refining content...",
    "applyingClassifications": "Applying classifications...",
    "evaluatingCriteria": "Evaluating criteria...",
    "calculatingResults": "Calculating results...",
    "finalizingReport": "Finalizing...",
    "aiAssistantPlaceholder": "Write a text or dictate with the microphone...",
    "sendToDescriptive": "To descriptive",
    "aiChatEmpty": "Send a message to start the conversation",
    "carolinaAssistance": "Carolina Assistance",
    "send": "Send",
    "record": "Record",
    "generate": "Generate",
    "selectReference": "Select one of the references to continue",
    "errorGenerating": "Error generating the report",
    "noTemplateDetected": "No template detected",
    "reportGeneratedWithReference": "Report generated with the selected reference",
    "versionCreated": "New version created successfully",
    "errorCreatingVersion": "Error creating the version",
    "emptyRecording": "The recording is empty",
    "invalidServerResponse": "Error: invalid server response",
    "noAudioDetected": "No audio detected",
    "commandExecuted": "Command executed successfully",
    "audioTranscribed": "Audio transcribed successfully",
    "audioProcessingError": "Error processing audio",
    "microphoneAccessError": "Could not access the microphone",
    "descriptionRequired": "You must enter a description",
    "errorLoadingTemplates": "Could not load templates",
    "patient": "Patient",
    "patientId": "Patient ID",
    "patientIdPlaceholder": "ID...",
    "patientAge": "Age",
    "patientAgePlaceholder": "Years",
    "patientSex": "Sex",
    "patientSexPlaceholder": "Select...",
    "sexMale": "Male",
    "sexFemale": "Female",
    "studyDate": "Study date",
    "requestReason": "Request reason",
    "patientNamePlaceholder": "Last name, First name",
    "requestReasonPlaceholder": "Reason description...",
    "cancel": "Cancel",
    "cancelEditing": "Cancel editing",
    "patientNameRequired": "Patient name is required",
    "confirmHint": "Enter to confirm · Esc to cancel",
    "editPatient": "Edit patient",
    "deletePatient": "Delete patient",
    "contractReason": "Collapse reason",
    "expandReason": "Expand reason",
    "years": "Years",
    "modality": "Modality",
    "accessionNumber": "Accession No.",
    "referringPhysician": "Referring physician",
    "previousStudiesTitle": "Previous Studies",
    "previousStudiesHint": "View and compare with previous patient studies",
    "allProcedures": "All procedures",
    "study": "study",
    "studiesCount": "studies",
    "studyPlural": "studies",
    "batches": "Batches",
    "batchStudies": "Studies",
    "noBatches": "No pending batches",
    "continueBatch": "Continue",
    "noStudiesFound": "No previous studies found",
    "studyStatus_completed": "Completed",
    "studyStatus_pending": "Pending",
    "studyStatus_cancelled": "Cancelled",
    "loadPrevStudies": "Load previous studies",
    "reportClinicalInfo": "Clinical information",
    "reportTechnique": "Technique",
    "reportFindings": "Findings",
    "reportConclusion": "Conclusion",
    "conclusionType": "Conclusion",
    "conclusionBrief": "Brief conclusion",
    "conclusionNormal": "Normal conclusion",
    "conclusionExtensive": "Extensive conclusion",
    "conclusionBriefShort": "Brief",
    "conclusionNormalShort": "Normal",
    "conclusionExtensiveShort": "Extensive",
    "speedMode": "Speed mode",
    "fast": "Fast",
    "accurate": "Accurate",
    "fastModeDesc": "Quick generation",
    "accurateModeDesc": "Higher precision",
    "loadTemplate": "Load report without changes",
    "templateNotes": "Do you want to modify anything when generating the new report?",
    "templateNotesPlaceholder": "E.g.: Change liver findings, add 8mm pulmonary nodule…",
    "needDescriptive": "Write something in the text field to generate",
    "useAsTemplate": "Generate using this as a template",
    "noReportContent": "No report content available",
    "searchStudies": "Search by procedure or date…",
    "previousStudy": "Previous study",
    "makeChanges": "Make changes",
    "makeChangesPlaceholder": "Describe the changes you want to make to the comparative report…",
    "classificationSectionsEmpty": "The technique, findings and conclusion sections must be complete to classify",
    "classificationSuccess": "Classification completed successfully",
    "classificationError": "Error performing classification",
    "editorNotReady": "The editor is not ready",
    "classificationUnchanged": "The report content has not changed since the last classification.",
    "classificationNoFindings": "No compatible findings found for this classification",
    "classificationInResearch": "This feature is under research. If you would like to use it, please request it from your administrator.",
    "classifications": "Classifications",
    "classificationsTitle": "Classifications",
    "fleischnerClassification": "Fleischner Classification",
    "fleischnerDesc": "Incidental pulmonary nodules — Fleischner 2017",
    "analyzing": "Analyzing…",
    "classify": "Classify",
    "results": "Results",
    "table": "Table",
    "fleischnerCriteria": "Fleischner Criteria",
    "fleischner_toggleHighlight": "Toggle highlight visibility",
    "fleischnerDescription": "Follow-up guidelines for incidental pulmonary nodules detected by CT, based on size, number and nodule type.",
    "singleSolidNodule": "Single solid nodule",
    "multipleSolidNodules": "Multiple solid nodules",
    "subsolidNodules": "Subsolid nodules",
    "pureGroundGlass": "Pure ground glass",
    "partSolidNodule": "Part-solid nodule",
    "size": "Size",
    "lowRisk": "Low risk",
    "highRisk": "High risk",
    "followUp": "Follow-up",
    "noFollowUp": "No follow-up",
    "partSolidNote": "If solid component ≥ 6 mm, consider PET-CT or resection.",
    "reference": "Reference: MacMahon H et al.",
    "singleLt6LowRisk": "No follow-up",
    "singleLt6HighRisk": "CT at 12 months (optional)",
    "single6to8LowRisk": "CT at 6–12 months → consider at 18–24 months",
    "single6to8HighRisk": "CT at 6–12 months → repeat at 18–24 months",
    "singleGt8LowRisk": "Consider CT at 3 months, PET-CT or biopsy",
    "singleGt8HighRisk": "Same as low risk",
    "multipleLt6LowRisk": "No follow-up",
    "multipleLt6HighRisk": "CT at 12 months",
    "multipleGte6LowRisk": "CT at 3–6 months → consider at 18–24 months",
    "multipleGte6HighRisk": "CT at 3–6 months → repeat at 18–24 months",
    "ggLt6": "No follow-up",
    "ggGte6": "CT at 6–12 months → then every 2 years up to 5 years",
    "psLt6": "No follow-up",
    "psGte6": "CT at 3–6 months → if persistent, annual follow-up for 5 years",
    "conclusionNoFollowUp": "No follow-up required per Fleischner 2017 criteria.",
    "conclusionOptionalCT12": "Optional CT follow-up at 12 months is recommended per Fleischner 2017 criteria.",
    "conclusionCT6to12Consider18to24": "CT follow-up at 6-12 months is recommended, with consideration of additional follow-up at 18-24 months per Fleischner 2017 criteria.",
    "conclusionCT6to12Repeat18to24": "CT follow-up at 6-12 months is recommended, with additional follow-up at 18-24 months per Fleischner 2017 criteria.",
    "conclusionConsiderCT3PetBiopsy": "Consider CT at 3 months, PET-CT or biopsy per Fleischner 2017 criteria.",
    "conclusionCT12": "CT follow-up at 12 months is recommended per Fleischner 2017 criteria.",
    "conclusionCT3to6Consider18to24": "CT follow-up at 3-6 months is recommended, with consideration of additional follow-up at 18-24 months per Fleischner 2017 criteria.",
    "conclusionCT3to6Repeat18to24": "CT follow-up at 3-6 months is recommended, with additional follow-up at 18-24 months per Fleischner 2017 criteria.",
    "conclusionCT6to12Every2y5y": "CT follow-up at 6-12 months is recommended, followed by follow-up every 2 years for up to 5 years per Fleischner 2017 criteria.",
    "conclusionCT3to6Annual5y": "CT follow-up at 3-6 months is recommended; if persistent, annual follow-up for 5 years per Fleischner 2017 criteria.",
    "tirads_classification": "TI-RADS Classification",
    "tirads_desc": "Thyroid nodules — ACR TI-RADS 2017",
    "tirads_criteria": "ACR TI-RADS Criteria",
    "tirads_description": "Scoring system for thyroid nodules detected by ultrasound, based on composition, echogenicity, shape, margins and echogenic foci.",
    "tirads_composition": "Composition",
    "tirads_echogenicity": "Echogenicity",
    "tirads_shape": "Shape",
    "tirads_margin": "Margins",
    "tirads_echogenicFoci": "Echogenic Foci",
    "tirads_feature": "Feature",
    "tirads_points": "Points",
    "tirads_compositionCystic": "Cystic or almost completely cystic",
    "tirads_compositionSpongiform": "Spongiform",
    "tirads_compositionMixed": "Mixed cystic and solid",
    "tirads_compositionSolid": "Solid or almost completely solid",
    "tirads_echogenicityAnechoic": "Anechoic",
    "tirads_echogenicityHyperIso": "Hyperechoic or isoechoic",
    "tirads_echogenicityHypo": "Hypoechoic",
    "tirads_echogenicityVeryHypo": "Very hypoechoic",
    "tirads_shapeWider": "Wider-than-tall",
    "tirads_shapeTaller": "Taller-than-wide",
    "tirads_marginSmooth": "Smooth",
    "tirads_marginIllDefined": "Ill-defined",
    "tirads_marginLobulated": "Lobulated or irregular",
    "tirads_marginExtrathyroidal": "Extra-thyroidal extension",
    "tirads_fociNone": "None or large comet-tail artifacts",
    "tirads_fociMacro": "Macrocalcifications",
    "tirads_fociPeripheral": "Peripheral (rim) calcifications",
    "tirads_fociPunctate": "Punctate echogenic foci",
    "tirads_categoriesTitle": "Categories & Recommendations",
    "tirads_categoryCol": "Category",
    "tirads_fnaThreshold": "FNA if",
    "tirads_followUpThreshold": "Follow-up if",
    "tirads_tr1_name": "TR1 — Benign",
    "tirads_tr2_name": "TR2 — Not Suspicious",
    "tirads_tr3_name": "TR3 — Mildly Suspicious",
    "tirads_tr4_name": "TR4 — Moderately Suspicious",
    "tirads_tr5_name": "TR5 — Highly Suspicious",
    "tirads_scoringNote": "Sum points from each category (highest value in each). Applies only to nodules ≥ 1 cm or those with suspicious features.",
    "tirads_reference": "Reference: Tessler FN et al.",
    "tirads_conclusionTR1": "Thyroid nodule classified as TI-RADS 1 (benign). No FNA or follow-up required per ACR TI-RADS 2017.",
    "tirads_conclusionTR2": "Thyroid nodule classified as TI-RADS 2 (not suspicious). No FNA or follow-up required per ACR TI-RADS 2017.",
    "tirads_conclusionTR3": "Thyroid nodule classified as TI-RADS 3 (mildly suspicious). FNA recommended if ≥ 2.5 cm or follow-up if ≥ 1.5 cm per ACR TI-RADS 2017.",
    "tirads_conclusionTR4": "Thyroid nodule classified as TI-RADS 4 (moderately suspicious). FNA recommended if ≥ 1.5 cm or follow-up if ≥ 1 cm per ACR TI-RADS 2017.",
    "tirads_conclusionTR5": "Thyroid nodule classified as TI-RADS 5 (highly suspicious). FNA recommended if ≥ 1 cm or follow-up if ≥ 0.5 cm per ACR TI-RADS 2017.",
    "tirads_chooseOne": "Choose 1",
    "tirads_chooseAll": "All that apply",
    "tirads_sumPoints": "Sum points from all categories",
    "tirads_selectOptions": "Select options",
    "tirads_recommendationCol": "Recommendation",
    "tirads_noFnaNoFollowUp": "No FNA · No follow-up",
    "tirads_tr1_label": "Benign",
    "tirads_tr2_label": "Not Suspicious",
    "tirads_tr3_label": "Mildly Suspicious",
    "tirads_tr4_label": "Moderately Suspicious",
    "tirads_tr5_label": "Highly Suspicious",
    "garden_classification": "Garden Classification",
    "garden_desc": "Subcapital femoral neck fractures — Garden",
    "garden_criteria": "Garden Classification",
    "garden_description": "Classification system for subcapital femoral neck fractures based on the degree of displacement of bone fragments on AP radiograph.",
    "garden_fracturePattern": "Fracture pattern",
    "garden_trabecularPattern": "Trabecular pattern",
    "garden_chooseOne": "Choose 1",
    "garden_highestGrade": "The highest grade determines the classification",
    "garden_selectFeatures": "Select features",
    "garden_displacement": "Displacement",
    "garden_fractureIncomplete": "Incomplete fracture (valgus impaction, inferior cortex only)",
    "garden_fractureCompleteNondisplaced": "Complete fracture, non-displaced (both cortices broken, aligned)",
    "garden_fractureCompletePartial": "Complete fracture, partially displaced",
    "garden_fractureCompleteFull": "Complete fracture, fully displaced (no contact between fragments)",
    "garden_trabecularAngulated": "Angulated trabeculae (valgus impaction pattern)",
    "garden_trabecularInterrupted": "Interrupted trabeculae, aligned across fracture line",
    "garden_trabecularDisrupted": "Disrupted trabeculae with femoral head rotation",
    "garden_trabecularNone": "No trabecular continuity (complete separation)",
    "garden_gI_label": "Incomplete / Valgus impacted",
    "garden_gII_label": "Complete, non-displaced",
    "garden_gIII_label": "Complete, partially displaced",
    "garden_gIV_label": "Complete, fully displaced",
    "garden_scoringNote": "The final Garden grade is determined by the level of displacement observed. In clinical practice, grades I–II (non-displaced) and III–IV (displaced) are grouped for therapeutic decision-making.",
    "garden_reference": "Reference:",
    "garden_conclusionI": "Subcapital femoral neck fracture classified as Garden I (incomplete fracture / valgus impacted). Internal fixation with cannulated screws is recommended.",
    "garden_conclusionII": "Subcapital femoral neck fracture classified as Garden II (complete fracture, non-displaced). Internal fixation with cannulated screws is recommended.",
    "garden_conclusionIII": "Subcapital femoral neck fracture classified as Garden III (complete fracture, partially displaced). Partial or total arthroplasty is recommended based on patient age and activity level.",
    "garden_conclusionIV": "Subcapital femoral neck fracture classified as Garden IV (complete fracture, fully displaced). Partial or total arthroplasty is recommended based on patient age and activity level.",
    "garden_clickToInsert": "Click to insert the recommendation into the report",
    "garden_toggleHighlight": "Toggle highlight visibility",
    "eaton_classification": "Eaton-Littler Classification",
    "eaton_desc": "Trapeziometacarpal osteoarthritis (thumb base) — Eaton-Littler",
    "eaton_criteria": "Eaton-Littler Classification",
    "eaton_description": "Radiological classification system for trapeziometacarpal osteoarthritis based on joint space narrowing, osteophytes, subluxation, and scaphotrapeziotrapezoidal (STT) joint involvement.",
    "eaton_jointSpace": "Joint space",
    "eaton_osteophytes": "Osteophytes",
    "eaton_subluxation": "Subluxation",
    "eaton_sttJoint": "STT Joint",
    "eaton_chooseOne": "Choose 1",
    "eaton_highestStage": "The highest stage determines the classification",
    "eaton_selectFeatures": "Select features",
    "eaton_jointNormal": "Normal or slightly widened joint space",
    "eaton_jointSlightNarrowing": "Slight joint space narrowing",
    "eaton_jointMarkedNarrowing": "Marked joint space narrowing or destruction",
    "eaton_jointNarrowingBoth": "Marked narrowing of TMC + STT joint",
    "eaton_osteoAbsent": "No osteophytes",
    "eaton_osteoSmall": "Small osteophytes (< 2 mm)",
    "eaton_osteoLarge": "Osteophytes > 2 mm, subchondral sclerosis/cysts",
    "eaton_osteoBothJoints": "Osteophytes at TMC + STT joints",
    "eaton_subluxMinimal": "Subluxation ≤ 1/3 of articular surface",
    "eaton_subluxSlight": "Slight subluxation of TMC joint",
    "eaton_subluxSignificant": "Significant subluxation (> 1/3)",
    "eaton_subluxFixed": "Subluxation of TMC + fixed adduction deformity",
    "eaton_sttNormalI": "STT joint normal",
    "eaton_sttNormalII": "STT joint normal",
    "eaton_sttNormalIII": "STT joint normal",
    "eaton_sttAffected": "STT joint affected (narrowing, osteophytes, sclerosis)",
    "eaton_eI_label": "Pre-arthritic",
    "eaton_eII_label": "Mild arthrosis",
    "eaton_eIII_label": "Advanced arthrosis (TMC only)",
    "eaton_eIV_label": "Pantrapezial arthrosis (TMC + STT)",
    "eaton_scoringNote": "The final Eaton-Littler stage is determined by the most severe radiological finding. Stages I-II are generally managed conservatively, while stages III-IV require surgical evaluation.",
    "eaton_reference": "Reference:",
    "eaton_conclusionI": "Trapeziometacarpal osteoarthritis classified as Eaton-Littler I (pre-arthritic stage). Conservative treatment with splinting, anti-inflammatories, and rehabilitation is recommended.",
    "eaton_conclusionII": "Trapeziometacarpal osteoarthritis classified as Eaton-Littler II (mild arthrosis). Conservative treatment or surgery depending on clinical symptoms is recommended.",
    "eaton_conclusionIII": "Trapeziometacarpal osteoarthritis classified as Eaton-Littler III (advanced TMC joint arthrosis). Trapeziectomy or arthroplasty is recommended.",
    "eaton_conclusionIV": "Trapeziometacarpal osteoarthritis classified as Eaton-Littler IV (pantrapezial arthrosis, TMC + STT involvement). Arthrodesis or total arthroplasty is recommended.",
    "snyder_classification": "Snyder Classification",
    "snyder_desc": "Rotator cuff complete tears — Snyder",
    "snyder_criteria": "Snyder Classification",
    "snyder_description": "Classification system for complete rotator cuff tears (supraspinatus and/or infraspinatus) based on anteroposterior tear diameter and number of tendons involved.",
    "snyder_tearSize": "Tear size (AP)",
    "snyder_tendonCount": "Tendons involved",
    "snyder_chooseOne": "Choose 1",
    "snyder_highestGrade": "The highest grade determines the classification",
    "snyder_selectFeatures": "Select features",
    "snyder_tearSmall": "Full-thickness tear < 10 mm AP diameter",
    "snyder_tearMedium": "Full-thickness tear 10–20 mm AP diameter",
    "snyder_tearLarge": "Full-thickness tear > 20 mm AP diameter",
    "snyder_tearMassive": "Full-thickness tear involving ≥ 2 tendons",
    "snyder_tendonSingle": "Single tendon (supraspinatus or infraspinatus)",
    "snyder_tendonSingleRetracted": "Single tendon with moderate retraction",
    "snyder_tendonSingleAtrophy": "Single tendon with significant retraction/atrophy",
    "snyder_tendonMultiple": "Two or more tendons involved",
    "snyder_sC1_label": "Small complete tear (< 10 mm)",
    "snyder_sC2_label": "Medium complete tear (10–20 mm)",
    "snyder_sC3_label": "Large complete tear (> 20 mm)",
    "snyder_sC4_label": "Massive tear (≥ 2 tendons)",
    "snyder_scoringNote": "The final Snyder grade is determined by the most severe finding. C4 takes priority when two or more tendons are involved, regardless of tear size.",
    "snyder_reference": "Reference:",
    "snyder_conclusionC1": "Complete rotator cuff tear classified as Snyder C1 (small tear, < 10 mm AP diameter). Arthroscopic repair is recommended.",
    "snyder_conclusionC2": "Complete rotator cuff tear classified as Snyder C2 (medium tear, 10–20 mm AP diameter). Arthroscopic or mini-open repair is recommended.",
    "snyder_conclusionC3": "Complete rotator cuff tear classified as Snyder C3 (large tear, > 20 mm AP diameter). Open or arthroscopic repair is recommended based on retraction and tissue quality.",
    "snyder_conclusionC4": "Complete rotator cuff tear classified as Snyder C4 (massive tear involving two or more tendons). Tendon transfer or reverse shoulder arthroplasty should be considered.",
    "herbert_classification": "Herbert-Fisher Classification",
    "herbert_desc": "Scaphoid fractures — Herbert-Fisher",
    "herbert_criteria": "Carpal scaphoid · Herbert and Fisher, 1984",
    "herbert_description": "Classifies carpal scaphoid fractures by stability and evolution (Herbert and Fisher, 1984) and guides management.",
    "herbert_acutePattern": "Acute fracture",
    "herbert_instability": "Instability criterion",
    "herbert_chronicity": "Evolution",
    "herbert_chooseOne": "Choose 1",
    "herbert_optional": "Optional",
    "herbert_highestGrade": "The most severe type determines the classification",
    "herbert_selectFeatures": "Select features",
    "herbert_a1Tubercle": "Tubercle fracture",
    "herbert_a2WaistNondisplaced": "Non-displaced waist (confirmed by CT)",
    "herbert_b1DistalOblique": "Oblique fracture of the distal third",
    "herbert_b2WaistDisplaced": "Displaced or mobile waist",
    "herbert_b3ProximalPole": "Proximal pole",
    "herbert_b4Perilunate": "Trans-scaphoid perilunate fracture-dislocation",
    "herbert_b5Comminuted": "Comminuted",
    "herbert_instDisplacement": "Displacement > 1 mm",
    "herbert_instDisi": "DISI: scapholunate angle > 60°",
    "herbert_instAngle": "Lateral intrascaphoid angle > 35°",
    "herbert_instComminution": "Comminution",
    "herbert_instPerilunate": "Part of a perilunar injury",
    "herbert_cDelayed": "Delayed union",
    "herbert_d1Fibrous": "Fibrous nonunion (proximal pole usually viable)",
    "herbert_d2Mobile": "Mobile nonunion",
    "herbert_d3Sclerotic": "Sclerotic nonunion with defect and humpback deformity",
    "herbert_d4Avn": "Avascular necrosis with collapse and loss of architecture",
    "herbert_extB3a": "Scapholunate angle < 60°",
    "herbert_extB3b": "Scapholunate angle > 60°",
    "herbert_extShortLt2": "Shortening < 2 mm",
    "herbert_extShortGt2": "Shortening > 2 mm",
    "herbert_extSlac": "With SLAC changes",
    "herbert_tA_label": "Acute stable",
    "herbert_tB_label": "Acute unstable",
    "herbert_tC_label": "Delayed union",
    "herbert_tD_label": "Established nonunion",
    "herbert_recA": "Conservative treatment or percutaneous fixation.",
    "herbert_recB": "Surgical fixation.",
    "herbert_recC": "Surgery, often with bone graft.",
    "herbert_recD": "Surgery, often with bone graft.",
    "herbert_scoringNote": "The final type is determined by the most severe finding. Any of these criteria makes an acute fracture unstable (B): displacement > 1 mm, scapholunate angle > 60° (DISI), lateral intrascaphoid angle > 35°, comminution or perilunar injury. The proximal pole (B3) is always unstable because of its retrograde blood supply. Confirm A2 versus B2 with CT.",
    "herbert_reference": "Reference:",
    "herbert_conclusion": "Carpal scaphoid fracture classified as Herbert {{subtype}} ({{label}}). {{recommendation}}",
    "herbertUi": {
      "modeLabel": "Classification mode",
      "modeGuided": "Guided",
      "modeDirect": "Direct",
      "hintGuided": "Step by step down to the subtype.",
      "hintDirect": "All subtypes in view, one click.",
      "reset": "Clear",
      "directTitle": "Choose the subtype",
      "phaseTitle": "What stage is the fracture at?",
      "groupTitleAcute": "Is it stable?",
      "groupLedeAcute": "Stable: tubercle or incomplete waist fissure. Unstable: complete line, displacement, proximal pole, comminution or perilunate injury.",
      "groupTitleEvo": "How has it evolved?",
      "groupLedeEvo": "Delayed union if it can still heal; nonunion if the lack of union is established.",
      "subtypeTitle": "Subtype",
      "subtypeTitleD": "Type of nonunion",
      "groupBadge": "Group {{group}}",
      "selected": "Selected:",
      "aiSuggested": "AI",
      "imgAlt": "Illustration: {{name}}",
      "next": {
        "direct": "Choose the subtype you see in the image.",
        "phase": "Start by choosing whether the fracture is acute or already evolving.",
        "groupAcute": "Indicate whether the fracture is stable or unstable.",
        "groupEvo": "Indicate whether it is a delayed union or a nonunion.",
        "sub": "Choose the subtype of group {{group}}.",
        "done": "Classification complete: Herbert {{code}}. Copy the text for the report."
      },
      "panel": {
        "finalType": "Final type",
        "mgmt": "Suggested management",
        "scale": "Scale",
        "path": "Path",
        "report": "Report text",
        "copy": "Copy",
        "copied": "Copied",
        "disclaimer": "General guidance. The treatment decision rests with the clinical team."
      },
      "report": {
        "c": "Carpal scaphoid fracture type C of the Herbert classification: delayed union.",
        "sub": "Carpal scaphoid fracture type {{code}} of the Herbert classification ({{group}}): {{rep}}."
      },
      "phases": {
        "aguda": { "name": "Acute fracture", "text": "Recent trauma. Stability of the fracture line is assessed." },
        "evo": { "name": "Evolution", "text": "The fracture has not healed in the expected time." }
      },
      "groups": {
        "A": { "name": "Acute stable", "tile": "Stable", "text": "Tubercle or incomplete fissure of the waist.", "desc": "Acute stable fractures, which can be managed conservatively.", "mgmt": "Immobilization. Choose the subtype for detail." },
        "B": { "name": "Acute unstable", "tile": "Unstable", "text": "Complete, displaced, proximal pole, comminuted or with dislocation.", "desc": "Acute unstable fractures, at risk of displacement and nonunion.", "mgmt": "Usually internal fixation with a compression screw." },
        "C": { "name": "Delayed union", "tile": "Delayed union", "text": "Still not healed, with widening of the fracture line.", "desc": "The fracture has not healed within the expected time. The line persists, with irregular edges, widening or cysts.", "mgmt": "Compression screw fixation, with or without bone graft." },
        "D": { "name": "Established nonunion", "tile": "Nonunion", "text": "Established lack of healing: fibrous or sclerotic.", "desc": "Established lack of union between the fragments.", "mgmt": "Surgical treatment. Choose the subtype for detail." }
      },
      "types": {
        "A1": { "name": "Tubercle fracture", "short": "Tubercle", "desc": "Fracture of the distal tubercle, extra-articular and well vascularized.", "mgmt": "Conservative: splint or cast for 4–6 weeks.", "rep": "tubercle fracture" },
        "A2": { "name": "Incomplete waist fracture", "short": "Incomplete waist", "sub": "Fissure without displacement", "desc": "Fissure that does not cross the whole waist and has no displacement.", "mgmt": "Cast for 6–8 weeks, or percutaneous screw fixation if a quick return to activity is sought.", "rep": "incomplete, non-displaced fracture of the waist" },
        "B1": { "name": "Oblique fracture of the distal third", "short": "Oblique distal third", "desc": "Long oblique line in the distal third, subject to shear forces.", "mgmt": "Compression screw fixation.", "rep": "oblique fracture of the distal third" },
        "B2": { "name": "Complete waist fracture", "short": "Complete waist", "desc": "Complete line through the waist, with or without displacement.", "mgmt": "Compression screw fixation, percutaneous or open depending on displacement.", "rep": "complete fracture of the waist" },
        "B3": { "name": "Proximal pole fracture", "short": "Proximal pole", "desc": "Small proximal fragment that depends on retrograde blood supply.", "mgmt": "Early surgical fixation, usually through a dorsal approach.", "rep": "proximal pole fracture" },
        "B4": { "name": "Trans-scaphoid perilunate fracture-dislocation", "short": "Trans-scaphoid perilunate", "desc": "Scaphoid fracture associated with perilunate dislocation of the carpus.", "mgmt": "Urgent: immediate reduction, then open reduction with fixation and ligament repair.", "rep": "trans-scaphoid perilunate fracture-dislocation of the carpus" },
        "B5": { "name": "Comminuted fracture", "short": "Comminuted", "desc": "Multiple fragments at the fracture site.", "mgmt": "Screw fixation, with or without bone graft. CT helps planning.", "rep": "comminuted fracture" },
        "D1": { "name": "Fibrous nonunion", "short": "Fibrous", "sub": "Stable fibrous union", "desc": "Fibrous union between the fragments, without relevant sclerosis or deformity.", "mgmt": "Compression screw, with or without cancellous graft.", "rep": "fibrous nonunion" },
        "D2": { "name": "Sclerotic nonunion", "short": "Sclerotic", "sub": "Sclerotic edges and cysts", "desc": "Open focus with sclerotic edges and cysts; may be associated with humpback deformity.", "mgmt": "Resection of sclerotic tissue, corticocancellous graft and fixation. Vascularized graft if the proximal pole is not viable.", "rep": "sclerotic nonunion" }
      },
      "alerts": {
        "A1": { "h": "Good prognosis", "t": "Extra-articular and well vascularized; heals with immobilization." },
        "B2": { "h": "Measure displacement", "t": "More than 1 mm of gap or step points to open fixation." },
        "B3": { "h": "Risk of avascular necrosis", "t": "The proximal pole receives its blood supply retrogradely from distal." },
        "B4": { "h": "Urgency", "t": "Associated perilunate injury: requires immediate reduction." },
        "B5": { "h": "Plan with CT", "t": "Defines the number and size of fragments before surgery." },
        "C": { "h": "Follow-up", "t": "Assess bone bridging and the appearance of cysts with CT." },
        "D1": { "h": "Viable proximal pole", "t": "It usually keeps its blood supply: good prognosis with fixation." },
        "D2": { "h": "Humpback deformity", "t": "Assess scaphoid flexion and carpal instability (DISI)." },
        "D2b": { "h": "Viability", "t": "Study the proximal pole with contrast MRI before planning the graft." }
      },
      "hints": {
        "A2": { "h": "Is the line complete or displaced?", "t": "Then it is not A2 but B2. If the radiograph is unclear, confirm with CT.", "btn": "It is B2" },
        "B2": { "h": "Is it only an incomplete, non-displaced fissure?", "t": "Then it is A2, a stable fracture. If in doubt, confirm with CT.", "btn": "It is A2" },
        "B3": { "h": "The proximal pole is always B3", "t": "Even if the line is not displaced: its retrograde blood supply makes it unstable." }
      }
    },
    "tnm_lung_classification": "TNM Lung Classification",
    "tnmLungName": "TNM Lung",
    "tnm_lung_desc": "Non-small cell lung cancer — TNM 7th edition",
    "tnm_lung_criteria": "TNM Lung Classification",
    "tnm_lung_description": "Staging system for non-small cell lung cancer based on primary tumor (T), regional lymph nodes (N), and distant metastasis (M) descriptors, according to the 7th TNM Edition (IASLC/UICC/AJCC, 2010).",
    "tnm_lung_tumorDescriptor": "Primary Tumor (T)",
    "tnm_lung_nodeDescriptor": "Regional Lymph Nodes (N)",
    "tnm_lung_metastasisDescriptor": "Distant Metastasis (M)",
    "tnm_lung_chooseOne": "Choose 1",
    "tnm_lung_stageGrouping": "Stage determination",
    "tnm_lung_stage": "Stage",
    "tnm_lung_selectDescriptors": "Select T, N and M descriptors",
    "tnm_lung_survival5y": "5-year survival",
    "tnm_lung_scoringNote": "The final TNM stage is determined by combining T, N, and M descriptors. If M1 is present, the stage is always IV regardless of T and N.",
    "tnm_lung_reference": "Reference:",
    "tnm_lung_tTX": "TX — Primary tumor cannot be assessed",
    "tnm_lung_tT0": "T0 — No evidence of primary tumor",
    "tnm_lung_tTis": "Tis — Carcinoma in situ",
    "tnm_lung_tT1a": "T1a — Tumor ≤ 2 cm",
    "tnm_lung_tT1b": "T1b — Tumor > 2 cm and ≤ 3 cm",
    "tnm_lung_tT2a": "T2a — Tumor > 3 cm and ≤ 5 cm",
    "tnm_lung_tT2b": "T2b — Tumor > 5 cm and ≤ 7 cm",
    "tnm_lung_tT3": "T3 — Tumor > 7 cm, or chest wall / diaphragm / phrenic nerve invasion, or same lobe nodule(s)",
    "tnm_lung_tT4": "T4 — Invasion of mediastinum, heart, great vessels, trachea, carina, esophagus, vertebral body; or ipsilateral different lobe nodule(s)",
    "tnm_lung_nNX": "NX — Regional lymph nodes cannot be assessed",
    "tnm_lung_nN0": "N0 — No regional lymph node metastasis",
    "tnm_lung_nN1": "N1 — Ipsilateral peribronchial / hilar lymph node metastasis",
    "tnm_lung_nN2": "N2 — Ipsilateral mediastinal / subcarinal lymph node metastasis",
    "tnm_lung_nN3": "N3 — Contralateral mediastinal / hilar, scalene or supraclavicular lymph node metastasis",
    "tnm_lung_mM0": "M0 — No distant metastasis",
    "tnm_lung_mM1a": "M1a — Contralateral lung nodule(s), malignant pleural / pericardial effusion",
    "tnm_lung_mM1b": "M1b — Distant (extrathoracic) metastasis",
    "tnm_lung_conclusionOculto": "Lung cancer staged as Occult (TX N0 M0). Additional workup is recommended.",
    "tnm_lung_conclusion0": "Lung cancer staged as Stage 0 (Tis N0 M0, carcinoma in situ). Surgical resection is recommended.",
    "tnm_lung_conclusionIA": "Lung cancer staged as Stage IA (T1a-T1b N0 M0). Surgical resection (lobectomy) is recommended. 5-year survival: 73%.",
    "tnm_lung_conclusionIB": "Lung cancer staged as Stage IB (T2a N0 M0). Surgical resection ± adjuvant chemotherapy is recommended. 5-year survival: 58%.",
    "tnm_lung_conclusionIIA": "Lung cancer staged as Stage IIA (T1-T2a N1, T2b N0). Surgical resection plus adjuvant chemotherapy is recommended. 5-year survival: 46%.",
    "tnm_lung_conclusionIIB": "Lung cancer staged as Stage IIB (T2b N1, T3 N0). Surgical resection plus adjuvant chemotherapy is recommended. 5-year survival: 36%.",
    "tnm_lung_conclusionIIIA": "Lung cancer staged as Stage IIIA (T1-T2 N2, T3 N1-N2, T4 N0-N1). Chemoradiotherapy with surgical evaluation is recommended. 5-year survival: 24%.",
    "tnm_lung_conclusionIIIB": "Lung cancer staged as Stage IIIB (T4 N2, Any T N3). Chemoradiotherapy is recommended. 5-year survival: 9%.",
    "tnm_lung_conclusionIV": "Lung cancer staged as Stage IV (Any T, Any N, M1). Systemic therapy (chemotherapy / targeted / immunotherapy) is recommended. 5-year survival: 13%.",
    "tnm_lung_matrixTitle": "Staging matrix (T × N)",
    "tnm_lung_matrixDesc": "Stage resulting from combining T and N descriptors when M = M0. If M1a or M1b is present, the stage is always IV regardless of T and N.",
    "tnm_lung_matrixM1Note": "Any T, any N — always Stage IV",
    "tnm_lung_matrixOccult": "Occult",
    "smartBarPlaceholder": "Type here...",
    "noCommandsUnderstood": "I didn't quite understand what you want me to do. Could you be more specific, please?",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "textColor": "Text color",
    "custom": "Custom",
    "untitled": "Untitled report",
    "facturationRate": "Weekly billing",
    "billedReports": "billed reports",
    "vsLastWeek": "vs last week",
    "weeklyCompletionRate": "Weekly reports",
    "avgEditTime": "Average time per report",
    "avgEditTimeSub": "{{count}} reports this week",
    "avgEditTimeEmpty": "No editing data available",
    "byPeriod": {
      "month":  { "facturationRate": "Monthly billing",        "avgEditTimeSub": "{{count}} reports this month" },
      "week":   { "facturationRate": "Weekly billing",         "avgEditTimeSub": "{{count}} reports this week" },
      "day":    { "facturationRate": "Today's billing",        "avgEditTimeSub": "{{count}} reports today" },
      "last30": { "facturationRate": "Last 30 days billing",   "avgEditTimeSub": "{{count}} reports in the last 30 days" }
    },
    "moreStats": "View all the stats",
    "moreStatsDesc": "Analyze your productivity and trends",
    "previewingVersion": "Previewing version",
    "restoreAction": "Restore",
    "versionHistory": "Version history",
    "closePanel": "Close panel",
    "saveDocToSeeHistory": "Save the document to see the history.",
    "noVersionsSaved": "No versions saved yet.",
    "restoring": "Restoring…",
    "restoreThisVersion": "Restore this version",
    "loadMore": "Load more",
    "comparingDiffs": "Comparing differences",
    "exitPreview": "Exit preview",
    "versionRestored": "Version restored",
    "versionRestoreError": "Could not restore the version",
    "triggerAutosave": "Autosave",
    "triggerManualSave": "Manual save",
    "triggerAiGeneration": "AI generation",
    "triggerVoiceCommand": "Voice command",
    "triggerMagicWrite": "Magic write",
    "triggerTemplateInserted": "Template inserted",
    "triggerTemplateChange": "Template change",
    "sourceMagicWriting": "Magic write",
    "sourceManual": "Manual",
    "sourceDictation": "Dictation",
    "triggerVersionRestored": "Version restored",
    "standardTemplateHint": "You haven't specified any template, so I used the standard one.\n If you'd like, just tell me which template to use and I'll apply it right away.\n For example: “Use the chest CT template. In the pulmonary parenchyma...”.",
    "patientData": "Patient data",
    "patientHistory": "Patient history",
    "closePatientPanel": "Close patient panel",
    "demographics": "Demographics",
    "birth": "Birth",
    "age": "Age",
    "sex": "Sex",
    "studySection": "Study",
    "date": "Date",
    "descriptionLabel": "Description",
    "clinic": "Clinic",
    "reportHistory": "Report history",
    "signed": "Signed",
    "reportIssueTitle": "Report an issue",
    "reportIssueThanks": "Thank you for your report!",
    "reportIssueReview": "We will review it as soon as possible and work on fixing it.",
    "reportIssueDescribe": "Describe the issue",
    "reportIssuePlaceholder": "Describe in detail what happened, on which screen or action and how to reproduce it...",
    "reportIssueSendError": "Could not send the issue. Please try again.",
    "reportIssueConsent": "I agree that the Ainovis team may contact me for more details",
    "reportIssueDisclaimer": "We will use this information solely to improve our tool and resolve the reported issue.",
    "reportIssueSubmit": "Submit report",
    "menuFile": "File",
    "menuInsert": "Insert",
    "menuClassifications": "Classifications",
    "menuTemplates": "Templates",
    "menuSupport": "Support",
    "menuCopy": "Copy",
    "menuShare": "Share",
    "menuVersionHistory": "Version history",
    "menuDownloadPdf": "Download as PDF",
    "menuPrint": "Print",
    "menuRename": "Rename",
    "menuDelete": "Delete",
    "menuLanguage": "Language",
    "menuImage": "Image",
    "menuTable": "Table",
    "insertTable": "Insert table",
    "menuDivider": "Divider line",
    "menuChart": "Chart",
    "menuShortcuts": "Keyboard shortcuts",
    "menuAskCarolina": "Ask Carolina",
    "menuReportIssue": "Report an issue",
    "menuExploreTemplates": "Explore templates",
    "menuUseAinovisTemplates": "Use Ainovis templates",
    "menuCreateTemplate": "Create template",
    "saveAsTemplate": "Save as template",
    "templateNameInvalid": "Name can only contain letters, numbers, spaces, hyphens, apostrophes and dots",
    "templateNameAinovis": "An Ainovis template with that name already exists. Please choose a different name.",
    "templateNameGroup": "The template name cannot contain the name of your group.",
    "templateName": "Template name",
    "contentCopiedToClipboard": "Content copied to clipboard",
    "errorCopyingContent": "Could not copy the content",
    "noSavedDocToDelete": "No saved document to delete.",
    "deleteDocumentTitle": "Delete document",
    "confirmDeleteDocument": "Are you sure you want to delete this document? This action cannot be undone.",
    "documentDeleted": "Document deleted successfully.",
    "errorDeletingDocument": "Could not delete the document.",
    "errorDeleteForbidden": "You don't have permission to delete this draft.",
    "draftNoAccessTitle": "You don't have access to this draft",
    "draftNoAccessMessage": "Ask its author to share it with you.",
    "draftNotFoundTitle": "This draft doesn't exist",
    "draftNotFoundMessage": "Its author may have deleted it.",
    "noContentToExport": "No content to export.",
    "browserBlockedPopup": "The browser blocked the popup.",
    "saveTemplate": "Save template",
    "backToReports": "Back to reports",
    "untitledTemplate": "Untitled template",
    "templateTitleRequired": "You must add a title to the template",
    "actionVersions": "Versions",
    "actionPatients": "Patients",
    "actionReportsHistory": "Previous reports",
    "patientsSidebarTitlePatient": "Patient details",
    "patientsSidebarTitleHistory": "Patient history",
    "patientsSidebarClose": "Close patient panel",
    "patientsSidebarNotConnected": "Not Connected",
    "patientsSidebarTabPatient": "Patient details",
    "patientsSidebarTabHistory": "Report history",
    "patientsSidebarSectionDemographics": "Demographics",
    "patientsSidebarSectionStudy": "Current study",
    "patientsSidebarSectionClinical": "Clinical",
    "patientsSidebarLabelBirth": "Date of birth",
    "patientsSidebarLabelAge": "Age",
    "patientsSidebarLabelSex": "Sex",
    "patientsSidebarLabelModality": "Modality",
    "patientsSidebarLabelDate": "Date",
    "patientsSidebarLabelAccession": "Accession No.",
    "patientsSidebarLabelDescription": "Description",
    "patientsSidebarLabelReferring": "Referring physician",
    "patientsSidebarLabelReason": "Reason for request",
    "patientsSidebarAddReason": "Add reason for request",
    "patientsSidebarAddReasonShort": "Add",
    "patientsSidebarReasonHint": "You need to be connected to an external system (RIS/PACS) to enable this feature.",
    "patientsSidebarStudyUid": "Study UID",
    "patientsSidebarSexMale": "Male",
    "patientsSidebarSexFemale": "Female",
    "patientsSidebarYearsOld": "{{years}} years",
    "patientsSidebarNoPatientName": "Unnamed patient",
    "patientsSidebarReportFallbackTitle": "Report",
    "patientsSidebarNoReport": "No report",
    "patientsSidebarHistoryEmpty": "No previous reports available",
    "patientsSidebarHistoryUnread": "The reports could not be loaded",
    "patientsSidebarHistoryCount": "{{studies}} studies · {{reports}} reports",
    "priorViewerClose": "Close prior report",
    "priorViewerNoContent": "This report has no available content.",
    "priorViewerConclusion": "Conclusion",
    "patientSummaryButton": "Summarize",
    "patientSummaryButtonHint": "Summary of prior reports generated by Carolina",
    "patientSummaryTitle": "Patient summary",
    "patientSummaryRegenerate": "Regenerate",
    "patientSummaryCollapse": "Collapse summary",
    "patientSummaryExpand": "Expand summary",
    "patientSummaryShowMore": "Show all",
    "patientSummaryShowLess": "Show less",
    "patientSummaryStepAnalyzing": "Analyzing prior reports ({{count}})…",
    "patientSummaryStepWriting": "Writing summary…",
    "patientSummaryNoPriors": "There are no prior reports with text that can be analyzed.",
    "patientSummaryNoFindings": "No relevant history was found in the prior reports.",
    "patientSummaryStale": "The prior reports have changed since this summary was generated.",
    "patientSummaryRetry": "Retry",
    "patientSummaryErrorGeneric": "The summary could not be generated.",
    "patientSummaryErrorTimeout": "The summary took too long. Please try again.",
    "patientSummaryErrorLimits": "There are too many prior reports to summarize at once.",
    "patientSummaryErrorUnavailable": "The summary service is not available right now.",
    "patientSummaryDisclaimer": "Generated by Carolina at {{time}} · Check the references",
    "patientSummaryReferences": "References ({{count}})",
    "patientSummaryViewInReport": "View in report",
    "actionAiAssistant": "AI Assistant",
    "actionMicQr": "Phone microphone",
    "micQrSidebarTitle": "Phone microphone",
    "micQrSidebarClose": "Close microphone panel",
    "micQrStep1": "Open the phone camera.",
    "micQrStep2": "Scan the QR code.",
    "micQrStep3": "Allow microphone access.",
    "micQrStep4": "Tap the record button.",
    "micQrNeedsPermission": "Allow microphone access on the phone before recording.",
    "micQrLoading": "Generating code…",
    "micQrError": "Could not create the code. Please try again.",
    "micQrExpired": "The code has expired",
    "micQrExpiresIn": "Expires in {{minutes}} min",
    "micQrHttpsHint": "The phone needs HTTPS (or localhost) to use the microphone.",
    "micQrRefresh": "Generate another code",
    "micQrWaiting": "Waiting for the phone…",
    "micQrStartRemote": "Connected to the phone microphone. Tap to record.",
    "micQrConnected": "Phone connected",
    "micQrConnectedHint": "Tap the record button.",
    "micQrDisconnect": "Disconnect",
    "useTemplate": "Use template",
    "newChat": "New chat",
    "closeAiPanel": "Close AI panel",
    "aiHeroText": "Ask me any question you have about Ainovis",
    "aiPlaceholder": "Write a message...",
    "aiErrorMessage": "Sorry, I could not process your question. Please try again.",
    "aiQuestion1": "How do I generate a report with the SmartBar?",
    "aiQuestion2": "How do I start voice dictation?",
    "aiQuestion3": "What medical classifications can I use?",
    "toolbarParagraphStyle": "Paragraph style",
    "toolbarFontFamily": "Font",
    "toolbarStyleNormal": "Normal text",
    "toolbarStyleH1": "Heading 1",
    "toolbarStyleH2": "Heading 2",
    "toolbarStyleH3": "Heading 3",
    "toolbarStyleH4": "Heading 4",
    "toolbarStyleH5": "Heading 5",
    "toolbarApplyStyleToAll": "Apply to all: \"{{style}}\"",
    "toolbarBold": "Bold (Ctrl+B)",
    "toolbarItalic": "Italic (Ctrl+I)",
    "toolbarUnderline": "Underline (Ctrl+U)",
    "toolbarStrikethrough": "Strikethrough",
    "toolbarTextColor": "Text color",
    "toolbarHighlightColor": "Highlight color",
    "toolbarHighlight": "Highlight",
    "toolbarNoColor": "None",
    "toolbarPresetColors": "Preset colors",
    "toolbarCustomColors": "Custom colors",
    "toolbarAddCustomColor": "Custom color...",
    "toolbarAlignLeft": "Align left",
    "toolbarAlignCenter": "Center",
    "toolbarAlignRight": "Align right",
    "toolbarJustify": "Justify",
    "toolbarBulletList": "Bullet list",
    "toolbarNumberedList": "Numbered list",
    "toolbarLineSpacing": "Line spacing",
    "toolbarRemoveSpaceBefore": "Remove space before paragraph",
    "toolbarAddSpaceBefore": "Add space before paragraph",
    "toolbarRestoreSpaceAfter": "Restore space after paragraph",
    "toolbarRemoveSpaceAfter": "Remove space after paragraph",
    "toolbarCustomSpacing": "Custom spacing…",
    "toolbarKeepWithNext": "Keep with next",
    "toolbarKeepLinesTogether": "Keep lines together",
    "toolbarAvoidOrphans": "Avoid orphan lines",
    "toolbarPageBreakBefore": "Add page break before",
    "toolbarDecreaseSize": "Decrease size",
    "toolbarIncreaseSize": "Increase size",
    "toolbarAlignment": "Alignment",
    "toolbarSingleSpacing": "Single",
    "toolbarDoubleSpacing": "Double",
    "toolbarZoom": "Zoom",
    "toolbarZoomOut": "Zoom out",
    "toolbarZoomIn": "Zoom in",
    "toolbarUndo": "Undo (Ctrl+Z)",
    "toolbarRedo": "Redo (Ctrl+Y)",
    "toolbarMoreOptions": "More formatting options",
    "toolbarFindingsMode": "Findings mode",
    "toolbarFindingsFirst": "Findings first",
    "toolbarFindingsFirstDesc": "Findings are placed above normal ones",
    "toolbarFindingsInside": "Findings within the text",
    "toolbarFindingsInsideDesc": "Findings are integrated in the report body",
    "toolbarHighlightFindings": "Highlight findings",
    "toolbarLineSpacingSingle": "Single",
    "toolbarLineSpacingDouble": "Double",
    "toolbarLanguagePlaceholder": "Language"
  },
  "inconsistencies": {
    "label": "Inconsistency",
    "show": "Show",
    "hide": "Dismiss",
    "mixedLateralityTerm": "Mixed lateralities",
    "mixedLateralityReason": "Different lateralities (RIGHT and LEFT) were detected in the same study. Please verify if this is correct.",
    "missingLateralityTerm": "Missing laterality",
    "missingLateralityReason": "The procedure requires laterality but none (right or left) was detected in the technique."
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Customize language and report format",
    "profile": "Profile",
    "account": "Account",
    "preferences": "Preferences",
    "language": "Language",
    "languageDescription": "Select the user interface language",
    "theme": "Theme",
    "themeDescription": "Choose the application color theme",
    "themeOptions": {
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "notifications": "Notifications",
    "security": "Security",
    "changePassword": "Change password",
    "currentPassword": "Current password",
    "privacyPolicy": "Privacy policy",
    "termsOfService": "Terms of service",
    "audio": "Audio",
    "audioDescription": "Configure the audio input device for dictation",
    "audioDevice": "Audio device",
    "audioDeviceDescription": "Select the microphone you want to use for dictation",
    "selectMicrophone": "Select microphone",
    "selectedDevice": "Selected device",
    "microphone": "Microphone",
    "onboarding": "Tutorial",
    "onboardingDescription": "View the application tutorial again",
    "onboardingText": "If you want to see the guided tutorial again, click the button to reactivate it. It will be shown the next time you access the corresponding screens.",
    "onboardingButton": "Reactivate tutorial",
    "onboardingResetSuccess": "Tutorial reactivated successfully",
    "session": "Session",
    "sessionDescription": "Manage your current session",
    "logoutText": "When you log out, you will be redirected to the login page",
    "signature": "Signature",
    "signatureDescription": "Write the text that will be inserted when you sign a report",
    "defaultSignatureName": "Dr. First Last",
    "signedBy": "Signed by",
    "colegiadoLabel": "License No.",
    "signatureHint": "Set your license number and professional title in the user administration section.",
    "signatureSaved": "Saved signature",
    "deleteSignature": "Delete signature",
    "generateSignature": "Generate signature",
    "ainovisTemplates": "Ainovis templates",
    "ainovisTemplatesDescription": "Use Ainovis predefined templates when generating reports",
    "ainovisTemplatesText": "Enable this option to use Ainovis templates. If you disable it, only your personal templates will be used."
  },
  "users": {
    "professionalTitle": "Title",
    "professionalTitlePlaceholder": "Dr., Dr., etc.",
    "practitionerIdentifier": "License No.",
    "practitionerIdentifierPlaceholder": "E.g.: 282812345",
    "practitionerIdentifierSystem": "Identification system",
    "practitionerIdentifierSystemPlaceholder": "URI of the professional college or registry",
    "title": "Users",
    "user": "user",
    "usersPlural": "users",
    "userList": "User list",
    "addUser": "Add user",
    "editUser": "Edit user",
    "deleteUser": "Delete user",
    "userDetails": "User details",
    "newUser": "New User",
    "management": "User Management",
    "subtitle": "Manage and view system user information",
    "searchPlaceholder": "Search by name, email or code...",
    "sortBy": "Sort by",
    "defaultSort": "Default (Name)",
    "nameAsc": "Name (A-Z)",
    "nameDesc": "Name (Z-A)",
    "surnameAsc": "Surname (A-Z)",
    "emailAsc": "Email (A-Z)",
    "emailDesc": "Email (Z-A)",
    "roleAsc": "Role (A-Z)",
    "roleDesc": "Role (Z-A)",
    "noUsers": "No users available",
    "showing": "Showing",
    "of": "of",
    "firstName": "First name",
    "lastName": "Last name",
    "role": "Role",
    "roleSuper": "Super",
    "roleAdmin": "Admin",
    "roleSupervisor": "Supervisor",
    "roleUser": "User",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "verified": "Verified",
    "pending": "Pending",
    "lastLogin": "Last login",
    "createSuccess": "User created successfully",
    "createError": "Error creating user",
    "updateSuccess": "User updated successfully",
    "deleteSuccess": "User deleted successfully",
    "notVerified": "User not verified",
    "notVerifiedDescription": "This user has not yet verified their email address.",
    "resendVerification": "Resend verification email",
    "resending": "Resending...",
    "emailSentSuccess": "Email sent successfully",
    "basicInfo": "Basic Information",
    "personalInfo": "Personal Information",
    "assignments": "Assignments",
    "code": "Code",
    "primaryEmail": "Primary Email",
    "secondaryEmail": "Secondary Email",
    "nationalId": "National ID",
    "birthDate": "Birth Date",
    "address": "Address",
    "account": "Account",
    "notSpecified": "Not specified",
    "required": "*",
    "optional": "(optional)",
    "namePlaceholder": "User's first name",
    "surnamePlaceholder": "User's last name",
    "emailPlaceholder": "user@example.com",
    "email2Placeholder": "optional@example.com",
    "searchAccountPlaceholder": "Search account...",
    "roleRadiologist": "Radiologist",
    "roleRadiologistDesc": "Basic system access",
    "roleSupervisorDesc": "Supervises and reviews reports",
    "roleAdminDesc": "Manages users in their account",
    "roleSuperDesc": "Full system access",
    "nameRequired": "First name is required",
    "nameMinLength": "First name must be at least 2 characters",
    "nameMaxLength": "First name is too long (maximum 100 characters)",
    "nameInvalidChars": "First name contains invalid characters",
    "surnameRequired": "Last name is required",
    "surnameMinLength": "Last name must be at least 2 characters",
    "surnameMaxLength": "Last name is too long (maximum 100 characters)",
    "surnameInvalidChars": "Last name contains invalid characters",
    "emailRequired": "Email is required",
    "emailInvalid": "Email format is invalid",
    "emailMaxLength": "Email is too long (maximum 255 characters)",
    "email2Invalid": "Secondary email format is invalid",
    "email2MaxLength": "Secondary email is too long (maximum 255 characters)",
    "roleRequired": "Role is required",
    "accountRequired": "Account is required",
    "saving": "Saving...",
    "create": "Create User",
    "createWithoutInvite": "Create without inviting",
    "update": "Update"
  },
  "accounts": {
    "title": "Accounts",
    "account": "account",
    "accountsPlural": "accounts",
    "accountList": "Account list",
    "addAccount": "Add account",
    "editAccount": "Edit account",
    "accountDetails": "Account details",
    "accountName": "Account name",
    "accountType": "Account type",
    "newAccount": "New account",
    "management": "Account management",
    "subtitle": "Manage hospitals, users and licenses",
    "searchPlaceholder": "Search by name or @domain...",
    "sortBy": "Sort by",
    "defaultSort": "Default (Updated)",
    "nameAsc": "Name (A-Z)",
    "nameDesc": "Name (Z-A)",
    "newestFirst": "Newest first",
    "oldestFirst": "Oldest first",
    "recentlyModified": "Recently modified",
    "notModified": "Not modified",
    "noAccounts": "No accounts found",
    "tryDifferentSearch": "Try different search terms",
    "createFirstAccount": "Create your first account to get started",
    "page": "Page",
    "of": "of",
    "domains": "Email domains",
    "noDomains": "No domains configured",
    "licenseLimits": "License limits",
    "administrators": "Administrators",
    "supervisors": "Supervisors",
    "radiologists": "Radiologists",
    "unlimited": "Unlimited",
    "metadata": "Metadata",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "deleteConfirm": "Are you sure you want to delete this account?",
    "deleteWarning": "This action cannot be undone and will delete all associated data.",
    "deletion": {
      "title": "Delete account {{name}}",
      "lead": "Deleting drags everything that hangs from the account. This cannot be undone.",
      "loading": "Calculating scope...",
      "planFailed": "Could not calculate the deletion scope.",
      "groups": "groups",
      "usersToDelete": "users will be deleted",
      "usersToDeactivate": "users will be deactivated (they have clinical history)",
      "gateways": "gateways will be deactivated in the Hub",
      "hubUnreachable": "The integration Hub is not responding. The account cannot be deleted without deactivating its gateways first.",
      "confirm": "Delete in cascade",
      "success": "Account deleted: {{groups}} groups, {{deleted}} users removed and {{deactivated}} deactivated."
    },
    "deleteSuccess": "Account deleted successfully",
    "createSuccess": "Account created successfully",
    "updateSuccess": "Account updated successfully",
    "nameRequired": "Name is required",
    "invalidNumber": "Must be a positive number",
    "invalidDomain": "Invalid format. Must be like @domain.com",
    "domainExists": "This domain has already been added",
    "addDomain": "Add domain",
    "domainPlaceholder": "@example.com",
    "optional": "(Optional, leave empty for unlimited)",
    "generalInfo": "General Information",
    "additionalInfo": "Additional information",
    "creationDate": "Creation date",
    "lastUpdate": "Last update",
    "deleteAccount": "Delete account?",
    "deleteAccountMessage": "This action will permanently delete the account {name} and cannot be undone.",
    "cancel": "Cancel",
    "confirmDelete": "Yes, delete",
    "accountNameField": "Account name",
    "requiredField": "*",
    "domainsDescription": "Add allowed email domains for this account",
    "domainInputPlaceholder": "E.g.: @hospital.com",
    "limitsDescription": "Set the maximum number of users per role",
    "maxAdmins": "Maximum administrators",
    "maxSupervisors": "Maximum supervisors",
    "maxRadiologists": "Maximum radiologists",
    "packageTypeTitle": "Package type",
    "packageTypeDescription": "Select the package level for this account",
    "packageType": "Package",
    "packageBronze": "Bronze",
    "packageSilver": "Silver",
    "packageGold": "Gold",
    "distributorTitle": "Distributor",
    "distributorDescription": "Select the distributor associated with this account. You can create new distributors.",
    "distributor": "Distributor",
    "hierarchy": {
      "title": "Organization structure",
      "manage": "Manage organization",
      "manageHint": "Groups, team, institutional templates and policies, in the organization panel."
    },
    "distributorDefault": "Default",
    "distributorCreate": "Create distributor…",
    "distributorCreatePlaceholder": "E.g.: NEW_DISTRIBUTOR",
    "distributorNameRequired": "Enter a valid name"
  },
  "groups": {
    "management": "Group Management",
    "subtitle": "Manage platform medical groups",
    "newGroup": "New Group",
    "editGroup": "Edit Group",
    "searchPlaceholder": "Search by name or tax ID...",
    "group": "group",
    "groupsPlural": "groups",
    "noGroups": "No groups found",
    "tryDifferentSearch": "Try different search terms",
    "createFirstGroup": "Create your first group to get started",
    "generalInfo": "General Information",
    "contactInfo": "Contact Information",
    "accountInfo": "Account Information",
    "code": "Code",
    "groupName": "Group name",
    "groupNamePlaceholder": "E.g.: North Diagnostic Group",
    "nationalId": "Tax ID",
    "nationalIdPlaceholder": "E.g.: B12345678",
    "address": "Address",
    "addressPlaceholder": "E.g.: 45 Health Avenue",
    "email": "Contact email",
    "emailPlaceholder": "E.g.: contact@group.com",
    "phone": "Contact phone",
    "phonePlaceholder": "E.g.: +1 555 123 456",
    "account": "Account",
    "selectAccount": "Select account...",
    "delete": "Delete",
    "edit": "Edit",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update": "Update",
    "create": "Create Group",
    "deleteSuccess": "Group deleted successfully",
    "createSuccess": "Group created successfully",
    "updateSuccess": "Group updated successfully",
    "nameRequired": "Name is required",
    "addressRequired": "Address is required",
    "emailRequired": "Email is required",
    "phoneRequired": "Phone is required",
    "accountRequired": "Account is required",
    "invalidEmail": "Invalid email format",
    "notSpecified": "Not specified",
    "notAssigned": "Not assigned",
    "close": "Close",
    "loadError": "Error loading groups"
  },
  "validation": {
    "required": "This field is required",
    "invalidEmail": "Invalid email",
    "passwordTooShort": "Password must be at least 8 characters",
    "passwordMismatch": "Passwords do not match",
    "invalidFormat": "Invalid format"
  },
  "navigation": {
    "home": "Home",
    "dashboard": "Dashboard",
    "reports": "Reports",
    "templates": "Templates",
    "users": "Users",
    "accounts": "Accounts",
    "settings": "Settings"
  },
  "templates": {
    "title": "Templates",
    "preparationNoticeLabel": "Templates are being saved.",
    "preparationNoticeHint": "Wait before using dictation.",
    "preparationNoticeDetail": "The templates have been saved, but they are still being prepared for dictation. Wait for this notice to disappear.",
    "galleryTitle": "Template gallery",
    "viewAllTemplates": "View all templates",
    "count": "{{count}} templates",
    "all": "All",
    "personal": "Personal",
    "emptyPersonal": "You have no associated templates.",
    "createFirst": "Create new template",
    "newTemplate": "New template",
    "searchPlaceholder": "Search template...",
    "allTypes": "All types",
    "allSources": "All sources",
    "allLanguages": "All languages",
    "customSelect": "Select language",
    "showing": "Showing",
    "template": "template",
    "templates_plural": "templates",
    "searching": "Searching templates...",
    "loadingMore": "Loading more templates...",
    "empty": "No templates found.",
    "emptyHint": "Add new templates",
    "newTemplateTitle": "New Template",
    "details": "Details",
    "selectTemplate": "Select a template…",
    "templateName": "Template name",
    "templateNameLabel": "Template Name",
    "templatePlaceholder": "Ex: MRI_KNEE_CONTRAST",
    "isBlock": "Is it a block?",
    "no": "No (Normal)",
    "yes": "Yes (Block)",
    "activationWord": "Activation word",
    "activationWordLabel": "Activation word",
    "activationWordPlaceholder": "Ex: TUMOR, LESION, etc.",
    "activationWordInfo": "The activation word allows distinguishing templates from the same anatomical area. For example, for pancreatitis you can use 'PANCREATITIS' to differentiate it from other pancreas templates.",
    "autoUppercase": "Will be automatically converted to uppercase",
    "standard": "Standard",
    "defaultBadge": "Standard",
    "setDefault": "Use “{{name}}” as your standard template",
    "unsetDefault": "Stop using “{{name}}” as your standard template",
    "defaultSet": "“{{name}}” is now your standard template",
    "defaultUnset": "You no longer have your own standard template",
    "defaultError": "Couldn't change the standard template",
    "standardInfoTitle": "Standard Template",
    "standardInfoBody": "",
    "standardInfoIntro": "The standard template is designed for general radiology studies. It uses dynamic markers in the technique that are automatically replaced when generating the report.",
    "standardInfoTechniqueTitle": "Technique",
    "standardInfoTechniqueBody": "The technique includes dynamic markers in double brackets (such as [[laterality]], [[sequences]], [[anatomical_regions]]) that the system automatically replaces with the corresponding values when generating the report.",
    "standardInfoTechniqueExample": "[[laterality]] Knee MRI is performed [[sequences]].",
    "standardInfoFindingsTitle": "Findings",
    "standardInfoFindingsBody": "Findings are written as continuous descriptive text in prose format, describing the evaluated structures and their characteristics in a narrative way.",
    "standardInfoUseCaseTitle": "When to use it?",
    "standardInfoUseCaseBody": "Ideal for general radiology studies: CT of extremities, knee MRI, spine, abdomen, ultrasounds, X-rays, etc.",
    "infoExample": "E.g.:",
    "content": "3. Template Content",
    "contentPlaceholder": "Drag a .txt file here or write the content...",
    "dragFile": "📄 Drag a .txt file here",
    "referenceIf": "4. Activation Reference (REFERENCE_IF)",
    "alwaysActive": "Always active (ALWAYS)",
    "referenceIfWarning": "⚠️ Cannot have two REFERENCE_IF = ALWAYS for the same procedure",
    "activationWordRequired": "Activation word:",
    "activationWordInputPlaceholder": "E.g.: PATHOLOGY, URGENT...",
    "language": "Language Code",
    "type": "Type",
    "saving": "Saving...",
    "saveChanges": "Save Changes",
    "createTemplate": "Create Template",
    "creating": "Creating template...",
    "nameRequired": "Template name is required",
    "activationRequired": "Must enter an activation word for blocks",
    "activationOrAlways": "Must enter an activation word or check \"Always active\"",
    "supportsBilaterality": "ℹ️ Supports unilaterality and bilaterality",
    "viewOtherTechnique": "Review template with opposite bilaterality/unilaterality",
    "relatedTechnique": "Related technique (Bilateral/Unilateral)",
    "contentRequired": "Template content cannot be empty",
    "techniqueRequired": "Technique content cannot be empty",
    "findingsRequired": "Findings content cannot be empty",
    "conclusionRequired": "Conclusion content cannot be empty",
    "technique": "Technique",
    "techniquePlaceholder": "Write the technique content...",
    "techniquePlaceholderStandard": "E.g.: [[laterality]] Knee MRI is performed [[sequences]].",
    "findings": "Findings",
    "findingsBlocks": "Findings",
    "findingsPlaceholder": "Write the findings content...",
    "findingsPlaceholderStandard": "E.g.: Osseous structures with normal marrow signal, no edema or focal lesions.",
    "conclusion": "Conclusion",
    "conclusionPlaceholder": "Write the conclusion content...",
    "conclusionPlaceholderStandard": "E.g.: Examination without significant findings.",
    "noProcedures": "No procedures associated with your template",
    "templateCreated": "Template created successfully",
    "errorSaving": "Error saving template",
    "normal": "Normal",
    "pathology": "Pathology",
    "urgent": "Urgent",
    "followUp": "Follow-up",
    "pediatric": "Pediatric",
    "USER": "User",
    "STANDARD": "Standard",
    "AINOVIS": "Ainovis",
    "procedureAssignment": "Assign Procedures",
    "procedureAssignmentExplanation": "When you generate a report and one of the assigned procedures is detected, this template will be automatically used to generate the report.",
    "groupFull": "Group full",
    "principal": "Principal",
    "complementary": "Complementary",
    "procedure": "Procedure",
    "addPrincipalFirst": "First add a principal procedure",
    "dragOrAssign": "Drag or assign procedures",
    "suggestedProcedures": "Suggested procedures",
    "availableProcedures": "Available procedures",
    "highRelevance": "High relevance",
    "mediumRelevance": "Medium relevance",
    "assignAsPrincipal": "Assign as Principal",
    "assignAsComplementary": "Assign as Complementary",
    "confirmSelection": "Confirm selection",
    "remove": "Remove",
    "resolving": "Resolving template with procedures...",
    "contentLabel": "Template",
    "groupsDescription": "Create groups of procedures to associate with this template",
    "assignedGroups": "Procedure groups",
    "group": "Group",
    "groupsPlural": "groups",
    "groupsExamples": "Group examples",
    "singleExample": "Single",
    "singleExampleValue": "Knee → A single procedure",
    "multiExample": "Multi",
    "multiExampleValue": "Knee + Leg → Multiple procedures together",
    "clickToAddProcedure": "Click or drag a procedure to add it",
    "single": "Single",
    "multi": "Multi",
    "removeGroup": "Remove group",
    "selectGroup": "Select group",
    "whereToAdd": "Where do you want to add",
    "createNewGroup": "Create new group",
    "add": "Add",
    "assigned": "Assigned",
    "dropHere": "Drop here to create a group",
    "dropToCreateGroup": "Drop here for new group",
    "expandList": "Expand list",
    "collapseList": "Collapse list",
    "activationReference": "Activation reference",
    "alwaysActiveDesc": "Template activates always",
    "customReference": "Custom reference",
    "customReferenceDesc": "Write an activation keyword",
    "customActivation": "Custom activation",
    "selectDestination": "Select destination",
    "addToExisting": "Add to existing",
    "willCreateMulti": "Will create a Multi-procedure",
    "willCreateSingle": "Will create a Single procedure",
    "full": "Full",
    "createNewSection": "Create new",
    "createNewProcedure": "Create as Single procedure",
    "assignedProcedures": "Assigned procedures",
    "item": "item",
    "items": "items",
    "examples": "Examples",
    "singleProcedure": "Single procedure",
    "multiProcedure": "Multi-procedure",
    "collapse": "Collapse",
    "expand": "Expand",
    "dropToCreate": "Drop here to create new",
    "templateContent": "Template content",
    "block": "Pathological",
    "howToTemplates": "How templates work",
    "chipLegendSelector": "Selector",
    "chipLegendPlaceholder": "Placeholder",
    "chipInsertHint": "Click on a field or type <kbd>/</kbd> to insert",
    "stepConfigureTemplate": "Configure",
    "stepSelectMarkers": "Markers",
    "stepAssignProcedures": "Procedures",
    "analyzeTemplate": "Analyze template",
    "assignProcedures": "Assign procedures",
    "saveTemplate": "Save template",
    "blocksHint": "Blocks only require findings and an activation word. Technique and conclusion are omitted.",
    "normalHint": "Normal templates include technique, findings and conclusion.",
    "standardHint": "Free text to describe findings without a fixed structure.",
    "cancelConfirmTitle": "Discard changes?",
    "cancelConfirmMessage": "You have unsaved changes. What would you like to do?",
    "discardChanges": "Discard",
    "keepEditing": "Keep editing",
    "draftSaved": "Draft saved",
    "draftSavedJustNow": "Draft saved",
    "fieldRequired": "This field is required",
    "procedureStepIntro": "Step 1: Click a procedure to assign it.",
    "procedureStepGroup": "Step 2: If groups exist, choose where to add it.",
    "procedureStepConfirm": "Step 3: Confirm the selection when done.",
    "confirmDelete": "Are you sure you want to delete this template? All associated versions (bilateral/unilateral) and their relationships with procedures will be removed.",
    "voiceChipTemplate": "Use the template",
    "voiceChipTemplatesHint": "Dictate «Use the template ...» or select",
    "copyAsPersonal": "Copy as personal",
    "copying": "Copying...",
    "copySuccess": "Copied!",
    "copyError": "Error copying the template",
    "copyConflictTitle": "Procedure conflict",
    "copyConflictMessage": "Personal templates already exist for the procedures assigned to this template:",
    "copyConflictHint": "To use this template, you must assign an activation word to differentiate it from existing ones.",
    "copyWithActivation": "Copy with activation",
    "help": {
      "title": "How to create templates",
      "intro": "Templates allow you to generate radiology reports quickly and consistently. Write the base report text and add <strong>variable fields</strong> where you need dynamic values.",
      "selectorTitle": "Selector",
      "selectorDesc": "Defines a list of possible options for a field. When generating the report, one of them will be chosen. Optionally, you can mark a <strong>default value</strong> that will be used if none is specified.",
      "exampleInEditor": "Example in the editor:",
      "selectorExampleChip": "preserved / increased / decreased: *preserved*",
      "selectorDetail": "This means: the options are «preserved», «increased» and «decreased». If nothing else is specified, <strong>«preserved»</strong> will be used as the default. The default is optional — if you don't set one, the options will simply be shown without a preselected value.",
      "placeholderTitle": "Placeholder",
      "placeholderDesc": "A generic marker that will be <strong>replaced</strong> by a specific value when generating the report (a description, a measurement, a finding, etc.).",
      "placeholderExampleChip": "finding",
      "placeholderDetail": "This marker will be replaced by the corresponding text when the final report is generated.",
      "tipTitle": "💡 Tip",
      "tipText": "Type <kbd>/</kbd> in the editor to open the quick field insertion menu, or use the buttons in the top bar of each section.",
      "ok": "Got it"
    },
    "source": "Source",
    "galleryNormalPrefix": "Gallery of ",
    "galleryBlockPrefix": "Gallery of ",
    "galleryBlockSuffix": "",
    "gallerySubtitle": "Manage your report templates and blocks",
    "countShown": "{{count}} templates",
    "countShown_one": "{{count}} template",
    "countShown_other": "{{count}} templates",
    "blocksCountShown": "{{count}} blocks",
    "blocksCountShown_one": "{{count}} block",
    "blocksCountShown_other": "{{count}} blocks",
    "blocksWord": "Blocks",
    "templatesWord": "templates",
    "myTemplates": "Your templates",
    "import": "Import template",
    "importTemplates": "Import templates",
    "importDropTitle": "Drop a DOCX, PDF or TXT here",
    "importDropActive": "Drop the files here",
    "importDropHint": "Or click to choose files",
    "importAddMore": "Add more files or continue",
    "importFilesCount": "{{count}} files",
    "importTotalSize": "{{count}} files · {{size}} of {{limit}}",
    "importTotalTooLarge": "The total size of the files exceeds the {{limit}} limit",
    "importProcessingN": "Processing document {{current}} of {{total}}…",
    "importFormats": "Supported formats: .docx, .pdf, .txt · Max 25 MB in total",
    "importInvalidFormat": "Unsupported format. Use a .docx, .pdf or .txt file",
    "importProcessing": "Processing document…",
    "importSaving": "Importing…",
    "importSaveFailed": "The templates could not be imported",
    "importPartialFailure": "Could not import: {{titles}}",
    "importDone": "{{created}} templates created and {{replaced}} replaced",
    "importSkippedAinovis": "Skipped because they match Ainovis templates: {{titles}}",
    "importFailed": "The document could not be processed",
    "importEmpty": "No template was found in the document.",
    "importRemoveFile": "Remove file",
    "importSplitTitle": "Split document",
    "importSplitHint": "Choose how to separate the templates in the document.",
    "importSplitAi": "AI detection",
    "importSplitAiHint": "AI detects each template in the document.",
    "importSplitPageBreaks": "Page breaks",
    "importSplitPageBreaksHint": "One template per page of the document.",
    "importSplitHorizontalLine": "Horizontal line",
    "importSplitHorizontalLineHint": "Splits the document at each horizontal line.",
    "importPreviewTitle": "Preview",
    "importFoundCount": "{{count}} templates found",
    "importSplitBy": "Split by",
    "importNameLabel": "Template name",
    "importWordCount": "{{count}} words",
    "importNoConflict": "No existing template has this name.",
    "importReplaces": "Replaces “{{name}}”",
    "importAinovisConflict": "An Ainovis template already uses that name",
    "importAinovisConflictFull": "An Ainovis template already uses that name. Change it to import this one.",
    "importDuplicateInDocument": "Name repeated in this document",
    "importDuplicateInDocumentFull": "Another template in this document already uses that name. Change it to import this one.",
    "importEmptyName": "Give it a name to import it",
    "importUntitled": "Untitled",
    "importBlocked": "Fix {{count}} name(s) to import",
    "importNameLabel": "Template name",
    "importFilledPerReport": "Filled in on each report",
    "importSummary": "{{total}} of {{found}} selected",
    "importChooseAnother": "Choose another file",
    "importConfirm": "Import {{count}} templates",
    "tabMine": "Personal",
    "tabShared": "Institutional",
    "tabAinovis": "Ainovis",
    "filterStandard": "Standard",
    "loading": "Loading templates...",
    "editTitle": "Edit template",
    "saveEdit": "Save changes",
    "filterSource": "Source",
    "filterLanguage": "Language",
    "normalTab": "Templates",
    "blocksTab": "Blocks",
    "filters": "Filters",
    "deleteTitle": "Delete template",
    "deleteConfirm": "Are you sure you want to delete <strong>{{name}}</strong>? This will remove all versions of this template and cannot be undone.",
    "deleting": "Deleting…",
    "delete": "Delete",
    "bulkDeleteTitle": "Delete templates",
    "bulkDeleteMessage": "Are you sure you want to delete {{count}} templates? This will delete all their versions and cannot be undone.",
    "selectedCount": "{{count}} selected",
    "selectTemplate": "Select “{{name}}”",
    "tabNormal": "Templates",
    "tabBlocks": "Blocks",
    "previewLabel": "Preview:",
    "apply": "Apply",
    "cancel": "Cancel"
  },
  "recommendations": {
    "title": "Suggestions",
    "show": "Show suggestions",
    "hide": "Hide suggestions",
    "list": "Available suggestions",
    "block": "Block",
    "classification": "Classification",
    "loading": "Loading suggestions…",
    "error": "Some suggestions could not be updated.",
    "noTemplate": "Select a template to see suggestions.",
    "empty": "No usage yet with this template.",
    "expandName": "Read full name",
    "collapseName": "Collapse name",
    "remove": "Remove {{name}} from suggestions"
  },
  "blocks": {
    "sectionContentPlaceholder": "Type here the content that will be inserted into the section...",
    "namePlaceholder": "Block name (e.g.: Acute pancreatitis)",
    "createHint": "This content will be inserted into the section where you drag it.",
    "empty": "No blocks",
    "createFirst": "Create block",
    "createCard": "Create block",
    "deleteTitle": "Delete block",
    "deleteConfirm": "Are you sure you want to delete <strong>{{name}}</strong>? This action cannot be undone.",
    "deleting": "Deleting…",
    "delete": "Delete",
    "cancel": "Cancel",
    "sidebarTitle": "Blocks",
    "searchToPin": "Search block...",
    "noResults": "No results",
    "expand": "Expand",
    "collapse": "Collapse",
    "addToTemplate": "Add",
    "unpin": "Unpin",
    "pinnedLoadError": "Pins are unavailable. You can still use blocks.",
    "preview": "Preview",
    "removeAssociation": "Remove from list"
  },
  "classificationCarousel": {
    "searchPlaceholder": "Search classification...",
    "empty": "No classifications found",
    "descriptions": {
      "FLEISCHNER": "Follow-up of incidental pulmonary nodules on CT.",
      "TI-RADS": "Malignancy risk of thyroid nodules on ultrasound.",
      "PI-RADS": "Suspicion of clinically significant prostate cancer on MRI.",
      "BOSNIAK_2019": "Stratification of cystic renal masses on CT or MRI.",
      "GARDEN": "Subcapital femoral neck fractures by displacement.",
      "EATON_LITTLER": "Staging of trapeziometacarpal osteoarthritis (thumb base).",
      "SNYDER": "Full-thickness rotator cuff tears by size and tendons involved.",
      "HERBERT_FISCHER": "Scaphoid fractures by stability and healing stage."
    }
  },
  "classificationRequest": {
    "title": "Request classification",
    "close": "Close",
    "successTitle": "Thank you for your request!",
    "successSub": "We will review your suggestion and work on adding the classification.",
    "intro": "Do you think a classification is missing? Tell us which one you need and we will evaluate adding it.",
    "descriptionLabel": "Describe the classification you need",
    "descriptionPlaceholder": "Enter the classification name, the specialty or study type it is used in, and any relevant details...",
    "submitError": "The request could not be sent. Please try again.",
    "allowContact": "I agree that the Ainovis team may contact me for more details",
    "disclaimer": "We will use this information solely to evaluate and develop new classifications.",
    "submitting": "Sending…",
    "submit": "Send request",
    "requestClassification": "Request classification"
  },
  "keyboardShortcuts": {
    "title": "Keyboard shortcuts",
    "close": "Close",
    "groupDictation": "Dictation",
    "dictationStart": "Start dictation",
    "dictationSend": "Send audio",
    "dictationSendAlt": "Send audio",
    "dictationPauseResume": "Pause / resume dictation",
    "dictationCancel": "Cancel dictation",
    "groupTextFormat": "Text formatting",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "strikethrough": "Strikethrough",
    "groupAlignment": "Alignment",
    "alignLeft": "Align left",
    "alignCenter": "Center",
    "alignRight": "Align right",
    "justify": "Justify",
    "groupEditing": "Editing",
    "undo": "Undo",
    "redo": "Redo",
    "selectAll": "Select all",
    "copy": "Copy",
    "cut": "Cut",
    "paste": "Paste",
    "save": "Save",
    "groupIndent": "Indentation",
    "indent": "Increase indent",
    "unindent": "Decrease indent",
    "groupView": "View",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "zoomReset": "Reset zoom",
    "key_space": "Space",
    "key_enter": "Enter",
    "key_esc": "Esc",
    "key_tab": "Tab",
    "key_shift": "Shift"
  },
  "aiSidebar": {
    "title": "Carolina",
    "newChat": "New chat",
    "closePanel": "Close AI panel",
    "heroText": "Ask me any question you have about Ainovis",
    "inputPlaceholder": "Type a message...",
    "errorMessage": "Sorry, I couldn't process your question. Please try again.",
    "question1": "How do I generate a report with the SmartBar?",
    "question2": "How do I start voice dictation?",
    "question3": "What medical classifications can I use?"
  },
  "diffModal": {
    "badge": "Template conversion",
    "progressOptions": "options",
    "title": "Markers detected in text",
    "subtitle": "Review the proposed changes to convert this report into a reusable template",
    "closeLabel": "Close modal",
    "selectMarkers": "Select markers",
    "slotsTitle": "Template construction options",
    "slotsSubtitle": "Select which markers to apply. Matching texts will be replaced.",
    "globalMode": "Global Mode",
    "individualMode": "Individual Mode",
    "useGlobalMarker": "Use global marker",
    "globalMarkerDescription": "Will apply the same marker to all anatomical regions",
    "finalResult": "Final result",
    "previewBadge": "Preview",
    "defaultValue": "Default value",
    "unspecified": "Unspecified",
    "defaultHint": "Highlighted parts use default values. Select all options to confirm.",
    "infoTitle": "What are markers?",
    "infoDescription": "Markers (e.g. [anatomical region], [laterality]) are fields that will be automatically filled when using this template, allowing it to be reused for different cases.",
    "warningTitle": "Complete all selections",
    "warningDescription": "{count} options remaining to select. Unselected slots are highlighted.",
    "keepOriginal": "Keep original",
    "applyTemplate": "Apply template",
    "lateralityDisabledByRegion": "Lateralities are disabled because anatomical regions already include them",
    "regionDisabledByLaterality": "Anatomical regions are disabled because lateralities are selected",
    "flexibilityTitle": "More flexible template",
    "flexibilityDescription": "By choosing markers, your report will be more versatile. Marked fields will be automatically filled based on the procedure, allowing you to reuse this template for multiple cases without manual editing.",
    "noMarkersTitle": "No markers selected",
    "noMarkersDescription": "Select at least one marker to apply changes to the technique, or continue to use the original text.",
    "replace": "Replace",
    "insert": "Insert"
  },
  "editor": {
    "sectionTitleEditToast": "Remember that you can edit default titles from settings"
  },
  "errors": {
    "authInvalidCredentials": "Incorrect email or password",
    "authInvalidToken": "Invalid or expired session",
    "authTokenExpired": "Your session has expired. Please log in again",
    "authMissingToken": "You must log in to access",
    "authUserNotFound": "User not found",
    "authUserAlreadyExists": "This user already exists",
    "authInactiveUser": "Your account is disabled. Contact the administrator",
    "authInsufficientPermissions": "You do not have sufficient permissions for this action",
    "authValidationError": "Data validation error",
    "validationError": "Please check the entered data",
    "templateNotFound": "Template not found",
    "templateValidationError": "Error in template data",
    "templateRetrievalError": "Error retrieving templates",
    "templateAlreadyExists": "A template with that name already exists",
    "templateNameDuplicate": "A template with that name already exists for this user",
    "templateReferenceIfConflictAlways": "A template \"{{templateName}}\" already exists for the procedure combination: {{procedureNames}}. Only one default template can exist per procedure combination.",
    "templateReferenceIfConflict": "A template \"{{templateName}}\" with the activation word \"{{referenceIf}}\" already exists for the procedure combination: {{procedureNames}}. Please use a different activation word.",
    "templateNoTemplatesFound": "No templates found for this user",
    "templateInvalidFormat": "Invalid template format",
    "templateAccessDenied": "You do not have access to this template",
    "blockLimitReached": "You have reached the limit of {{limit}} blocks. Delete one to create another.",
    "reportNotFound": "Report not found",
    "reportValidationError": "Error in report data",
    "reportGenerationError": "Error generating report",
    "reportSaveError": "Error saving report",
    "reportAlreadyExists": "A report with that identifier already exists",
    "reportRetrievalError": "Error retrieving reports",
    "reportModalityNotFound": "The selected modality does not exist",
    "reportAccessDenied": "You do not have access to this report",
    "reportDataInvalid": "Report data is not valid",
    "reportMissingField": "Required fields are missing in the report",
    "reportInvalidFormat": "Invalid report format",
    "reportInvalidGenerationRequest": "Invalid generation request",
    "reportApiError": "Error connecting to report service",
    "reportServiceError": "Error in report service",
    "reportAlignmentError": "Error during report alignment",
    "reportNoModalityOrRegions": "Could not detect modality or anatomical regions in the text",
    "reportTemplatesNotFoundForProcedure": "No templates found for your procedure and language",
    "reportTemplatesFoundForDifferentType": "No templates of the requested type were found for your procedure, but {{availableType}} templates exist",
    "reportTemplateType_STANDARD": "findings first or findings inside",
    "reportsTemplateNotFound": "No template available for this descriptive. You can create one to use it",
    "reportsTemplateIncomplete": "The template is incomplete and cannot be used to generate the report",
    "reportsTemplateContentNotFound": "Template content not found",
    "reportsTemplateContentIncomplete": "Template content is incomplete",
    "reportsPromptNotFound": "The prompt required for generation was not found",
    "reportsFindingsGenerationError": "Error generating report findings",
    "reportsConclusionGenerationError": "Error generating report conclusion",
    "reportsSectionGenerationError": "Error generating a report section",
    "reportsParallelGenerationError": "Error during parallel report generation",
    "reportsInvalidGenerationParameters": "Invalid generation parameters",
    "reportsAlignmentError": "Error during report alignment",
    "reportsPreSaveReviewError": "Error in pre-save review",
    "reportsLlmServiceError": "Error in artificial intelligence service",
    "reportLanguageCodeNotFound": "The requested language code was not found",
    "reportInactiveTemplate": "The selected template is inactive",
    "reportProcedureNotFound": "The requested procedure was not found",
    "reportAnatomicalRegionNotFound": "The requested anatomical region was not found",
    "reportVariantNotFound": "The requested variant was not found",
    "reportTemplateNotFound": "Report template not found",
    "ainovisApiError": "Error in AI service",
    "ainovisConnectionError": "Connection error with AI service",
    "ainovisTimeoutError": "AI service took too long to respond",
    "ainovisInvalidAudioFormat": "Invalid audio format",
    "ainovisAudioFileSizeExceeded": "Audio file is too large",
    "ainovisMissingAudioFile": "No audio file provided",
    "sttServiceError": "Error in transcription service",
    "sttValidationError": "Error in transcription data validation",
    "sttMissingField": "Required fields missing for transcription",
    "sttProcessingError": "Error processing audio",
    "sttApiError": "Error connecting to transcription service",
    "sttNoVoiceDetected": "No voice detected in the audio",
    "sttAudioProcessingError": "Error processing the audio file",
    "sttNoAudioChunks": "No valid audio chunks were generated",
    "sttTranscriptionError": "Error in speech-to-text transcription",
    "sttNoTranscriptionResults": "No transcription results were obtained",
    "sttEmptyTranscript": "The transcription was empty",
    "sttInvalidAudioFile": "The audio file is invalid or corrupted",
    "sttAudioFormatNotSupported": "The audio format is not supported",
    "emailSendFailed": "Error sending email",
    "emailInvalidConfig": "Invalid email configuration",
    "emailInvalidAddress": "Invalid email address",
    "emailTemplateNotFound": "Email template not found",
    "emailTemplateRenderError": "Error rendering email",
    "emailConnectionError": "Connection error with email server",
    "emailAuthenticationError": "Authentication error with email server",
    "networkError": "Connection error. Check your internet connection",
    "noResponse": "Server is not responding. Try again",
    "requestSetupError": "Error processing request",
    "unexpectedError": "An unexpected error occurred"
  },
  "billing": {
    "studies": "Studies",
    "revenue": "Revenue (€)",
    "modality": {
      "rx": "X-Ray",
      "eco": "Ultrasound",
      "tc": "CT",
      "rm": "MRI"
    }
  },
  "statistics": {
    "dateRange": "Jan 15 – Feb 15, 2026",
    "sections": {
      "productionVolume": "Production & Volume",
      "performanceEfficiency": "Performance & Efficiency",
      "billing": "Billing",
      "realtimeActivity": "Real-time Activity"
    },
    "kpi": {
      "reportsToday": "Reports Today",
      "activeRadiologists": "Active Radiologists",
      "averageTime": "Average Time",
      "templateUsage": "Template Usage",
      "vsYesterday": "12.3% vs yesterday",
      "thisWeek": "+2 this week",
      "vsAvg": "0.8 min vs avg.",
      "thisMonth": "5% this month"
    },
    "charts": {
      "reportsPerMonth": "Reports Generated per Month",
      "reportsPerMonthSubtitle": "Last 30 Days — Total: 22,487",
      "reportsPerMonthBadge": "+18% monthly",
      "billing": "Billing by Modality",
      "billingSubtitle": "Gold tier · Volume and revenue",
      "billingBadge": "🪩 Gold tier",
      "billingMonthly": "Monthly Revenue Trend",
      "billingMonthlySubtitle": "Last 6 months · Revenue by modality",
      "topRadiologists": "Metrics per Radiologist",
      "topRadiologistsSubtitle": "Reports this week per radiologist",
      "mostUsedTemplates": "Most Reported Procedures",
      "mostUsedTemplatesSubtitle": "Distribution by Type",
      "anatomicalRegions": "Findings by Procedure",
      "anatomicalRegionsSubtitle": "Number of findings per procedure",
      "heatmap": "Radiologist Comparison",
      "heatmapSubtitle": "Reports by radiologist and modality",
      "reportsByModality": "Reports by Modality",
      "reportsByModalitySubtitle": "Statistical distribution (box & whisker)",
      "timePerRadiologist": "Generation Time per Radiologist",
      "timePerRadiologistSubtitle": "Avg. Minutes vs Volume",
      "correlationMatrix": "Diagnostic Correlation Matrix",
      "correlationMatrixSubtitle": "Pearson concordance between radiologists (20 studies)",
      "correlationLegend": "Correlation coefficient (Pearson)",
      "frequentFindings": "Frequent Findings",
      "frequentFindingsSubtitle": "Frequency by finding type",
      "weeklyComparison": "Weekly Comparison",
      "weeklyComparisonSubtitle": "Top 5 — Current vs Previous",
      "realtimeFeed": "Real-time Feed",
      "realtimeFeedSubtitle": "Latest Reports",
      "live": "Live",
      "average": "Average",
      "reports": "reports",
      "currentMonth": "Current Month",
      "previousMonth": "Previous Month",
      "currentWeek": "Current Week",
      "previousWeek": "Previous Week",
      "reportsLabel": "Reports",
      "avgMinutes": "Avg. minutes",
      "volume": "Volume",
      "timeMins": "Time (min)",
      "time": "Time"
    },
    "days": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "specialties": {
      "neuroradiology": "Neuroradiology",
      "musculoskeletal": "Musculoskeletal",
      "chest": "Chest",
      "abdomen": "Abdomen",
      "breast": "Breast"
    },
    "templateNames": {
      "ctBrain": "CT Brain",
      "xrayChest": "X-Ray Chest",
      "mriKnee": "MRI Knee",
      "ctAbdomen": "CT Abdomen",
      "usThyroid": "US Thyroid",
      "other": "Other"
    },
    "regions": {
      "head": "Head",
      "chest": "Chest",
      "abdomen": "Abdomen",
      "spine": "Spine",
      "extremities": "Extremities",
      "pelvis": "Pelvis"
    },
    "findings": {
      "noFindings": "No findings",
      "pulmonaryNodule": "Pulmonary nodule",
      "discHerniation": "Disc herniation",
      "pleuralEffusion": "Pleural effusion",
      "fracture": "Fracture",
      "renalMass": "Renal mass",
      "aneurysm": "Aneurysm",
      "stenosis": "Stenosis",
      "calcification": "Calcification",
      "hepaticCyst": "Hepatic cyst"
    },
    "feed": {
      "minAgo": "{{value}} min ago"
    },
    "additionalTemplate": {
      "title": "Generate complementary version",
      "infoBanner": "This template may benefit from a complementary version (bilateral/unilateral). On the left, select what type of version you are writing here. The original template will automatically be saved as the opposite version. For example, if you choose 'Unilateral', what you write here will be the unilateral version and the original template will be saved as bilateral.",
      "selectVersion": "What type of version is it?",
      "selectionHint": "Indicate whether the complementary version you are writing is bilateral or unilateral.",
      "bilateral": "Bilateral",
      "bilateralDescription": "The complementary version applies to both sides (both knees, both shoulders, etc.)",
      "unilateral": "Unilateral",
      "unilateralDescription": "The complementary version applies to one side only, with a [laterality] label.",
      "selectedVersion": "{{option}} version selected",
      "noSelection": "Select a version type",
      "editContent": "Complementary version content",
      "edited": "Edited",
      "editHint": "Edit the fields to define the content of the complementary version. This will be the content that gets saved.",
      "technique": "Technique",
      "techniquePlaceholder": "Write the technique for the complementary version...",
      "findings": "Findings",
      "findingsPlaceholder": "Write the findings for the complementary version...",
      "impression": "Impression",
      "impressionPlaceholder": "Write the impression for the complementary version...",
      "skipGeneration": "Continue without additional",
      "save": "Save version"
    }
  },
  "onboarding": {
    "skip": "Skip",
    "next": "Next",
    "previous": "Back",
    "finish": "Got it!",
    "tryIt": "Try it!",
    "example": "Example",
    "interactionPending": "Type in the editor to continue",
    "interactionDone": "Great! You can continue",
    "welcomeTitle": "Welcome to Ainovis!",
    "welcomeDesc": "It looks like this is your first time here. Would you like a quick tour to learn about the main tools?",
    "skipTour": "Not now",
    "startTour": "Start tour",
    "reportCreate": {
      "editorTitle": "Dictation editor",
      "editorDesc": "This is where your dictation will appear. You can type directly or use the microphone to dictate the study.",
      "micTitle": "Voice dictation",
      "micDesc": "Press the microphone to start voice dictation. The microphone works in the app's language. If you're not comfortable, you can change the language in settings.",
      "generateTitle": "Generate report",
      "generateDesc": "Once you've dictated or typed the study description, press this button to automatically generate the report.",
      "modeTitle": "Automatic / Manual mode",
      "modeDesc": "Toggle between automatic mode (Ainovis selects the template) and manual mode (you choose the template to use).",
      "speedModeTitle": "Generation speed",
      "speedModeDesc": "Choose between fast mode (lower latency) or accurate mode (higher quality report generation).",
      "settingsTitle": "Report settings",
      "settingsDesc": "Configure the language, template type, and conclusion type before generating your report.",
      "tryRomTitle": "Now try it yourself!",
      "tryRomDesc": "Type a knee MRI (magnetic resonance imaging) study in the editor. You can copy the example or write whatever you'd like. This will show you how Ainovis generates a report.",
      "tryRomHint": "Type a knee MRI...",
      "tryRomExample": "knee MRI. Normal",
      "tryGenerateTitle": "Generate your first report!",
      "tryGenerateDesc": "Now press the send button to generate your report. Ainovis will process what you've written and create a complete report."
    },
    "reportEdit": {
      "lateralMenuTitle": "Side menu",
      "lateralMenuDesc": "In this side panel you'll find the report parameters. If you came from the creation screen, the settings you configured (language, template type, mode) will already be applied here.",
      "lateralMenuParamsTitle": "Regenerate with new parameters",
      "lateralMenuParamsDesc": "From here you can change the language, report type, conclusion type or speed and regenerate the report with the new parameters. You can also create new versions directly.",
      "patientBannerTitle": "Patient data",
      "patientBannerDesc": "Here you can associate patient data with the report: name, ID, age, sex, study date and reason for consultation. You can also access the patient's previous studies to compare or reuse earlier reports.",
      "mainEditorTitle": "Report editor",
      "mainEditorDesc": "This is the main editor where the generated report is displayed, divided into sections (Technique, Findings, Conclusion). You can freely edit the text, dictate by voice, and changes are automatically saved as a draft.",
      "versionTabsTitle": "Report versions",
      "versionTabsDesc": "Each time you regenerate the report or create a blank canvas, a new version is created. The tabs at the bottom let you navigate between versions, close ones you don't need, or create a new empty version with the + button.",
      "actionsTitle": "Report actions",
      "actionsDesc": "Use 'Copy' to copy the report to clipboard, 'Send' to save the report as final, or 'Delete' to discard the draft entirely."
    },
    "home": {
      "welcomeTitle": "Your control panel",
      "welcomeDesc": "This is your main dashboard. From here you can create new reports, upload audio for batch dictation, and access your entire work history.",
      "createBtnTitle": "Create report",
      "createBtnDesc": "Press this button to create a new report from scratch. The editor will open where you can dictate or type the study.",
      "uploadBtnTitle": "Upload audio",
      "uploadBtnDesc": "Upload audio files with multiple dictations. Ainovis will automatically transcribe and separate them into individual studies.",
      "performanceTitle": "Activity summary",
      "performanceDesc": "Here you can see your statistics: reports created, time saved, and productivity trends. Press 'View more stats' to access the full analytics panel.",
      "templatesTitle": "Templates",
      "templatesDesc": "The Templates tab holds your full report templates, ready to use when generating a report. Create new ones, edit existing ones, or use templates shared by your team.",
      "blocksTitle": "Blocks",
      "blocksDesc": "Switch to the Blocks tab: here you'll see blocks — reusable fragments (paragraphs, findings, descriptions) you can insert into any report to write faster.",
      "reportListTitle": "Work history",
      "reportListDesc": "Here you'll find all your drafts, saved reports, reports shared with you, and dictation batches. Use the tabs to filter."
    },
    "reportEditV2": {
      "smartBarTitle": "SmartBar — Your intelligent bar",
      "smartBarDesc": "The SmartBar is your main tool. Type a study description or dictate by voice and press send to automatically generate the report with Carolina. You can also use it to edit specific sections.",
      "canvasTitle": "Report editor",
      "canvasDesc": "This is the main editor where the generated report is displayed, divided into editable sections. You can freely modify the text and changes are saved automatically.",
      "toolbarTitle": "Toolbar",
      "toolbarDesc": "Customize text formatting: font, size, bold, italic, alignment, lists and more. Works like any rich text editor.",
      "findingsModeTitle": "Writing modes",
      "findingsModeDesc": "Here you choose how findings are written: “Findings first” groups them at the top, above the normal text; “Findings within the text” integrates them into the body of the report. You can switch mode at any time.",
      "menuBarTitle": "Menu bar",
      "menuBarDesc": "Access all features: file management, element insertion (images, tables, charts), medical classifications, templates and support.",
      "classificationsTitle": "Medical classifications",
      "classificationsDesc": "Access standardized classifications like Fleischner, TI-RADS, PI-RADS, Bosniak and more. Select the parameters and the classification will be automatically inserted into your report.",
      "versionsTitle": "Version history",
      "versionsDesc": "This is the report's version history. Every time you send, regenerate or apply a template, a version is saved here. The steps that changed each version are grouped by date so you can compare, preview and restore any previous version.",
      "patientsTitle": "Patients",
      "patientsDesc": "From this panel you search for and link the study's patient. Once selected, their data and previous studies stay connected to the report so you can consult or reuse earlier reports.",
      "patientsNotIntegrated": "This feature is not integrated yet. To see the patient's data and history, the report must be opened from an external system (RIS/PACS).",
      "reportsHistoryTitle": "Previous reports",
      "reportsHistoryDesc": "Here you see the history of saved reports and can consult them to compare findings with earlier studies.",
      "micQrTitle": "Mobile microphone",
      "micQrDesc": "Scan this code with your phone to use it as a wireless dictation microphone. The code expires after a while; if it disconnects, regenerate it from here.",
      "aiBtnTitle": "AI Assistant — Carolina",
      "aiBtnDesc": "Open Carolina's panel, your AI assistant. You can ask her questions about the report, request suggestions, or consult medical queries.",
      "testTemplateTitle": "Create your first template",
      "testTemplateDesc": "Click the “CREATE TEMPLATE” card: we'll fill in the name and a sample report for you.",
      "testTemplateSaveTitle": "Save your template",
      "testTemplateSaveDesc": "Your template is already filled in with a sample knee MRI report. Press “Save template” to finish.",
      "testTemplatePending": "Save the template to continue",
      "autoFillTemplateName": "Knee MRI test",
      "autoFillTemplateSectionTechnique": "TECHNIQUE",
      "autoFillTemplateTechniqueBody": "MRI study of the right knee with PD FS and T1 sequences in the three planes, without intravenous contrast administration.",
      "autoFillTemplateSectionFindings": "FINDINGS",
      "autoFillTemplateFindingsBody": "Menisci show normal morphology and signal intensity, with no evidence of tear. Cruciate and collateral ligaments are intact. Articular cartilage is preserved. No significant joint effusion. Normal bone marrow signal.",
      "autoFillTemplateSectionConclusion": "IMPRESSION",
      "autoFillTemplateConclusionBody": "Normal MRI study of the right knee.",
      "testBlockTitle": "Create your first block",
      "testBlockDesc": "Click the “Create block” card: we'll fill in a sample reusable fragment for you. You just have to press “Save”.",
      "testBlockPending": "Save the block to continue",
      "autoFillBlockName": "Medial meniscus tear",
      "autoFillBlockContent": "Horizontal tear of the posterior horn of the medial meniscus, extending to the inferior articular surface.",
      "testReportTitle": "Dictate your first report to Carolina",
      "testReportDesc": "Press the microphone and say the command below out loud. This is how you'll work every day: by speaking, not typing.",
      "testReportPending": "Say the command out loud to continue",
      "voiceGateIdle": "Press the microphone and say the command out loud.",
      "voiceGateSayThis": "Say out loud:",
      "voiceGateNoMic": "I can't use the microphone",
      "voiceGatePlaceholder": "Use the microphone →",
      "voiceGateChecking": "Listening to what you said…",
      "voiceGateHeard": "I understood:",
      "voiceGateMissingTemplate": "You didn't name your template.",
      "voiceGateMissingBlock": "You didn't name your block.",
      "voiceGateRetry": "Repeat the command exactly as shown above.",
      "voiceGateTypeFallback": "You can also type it in the bar.",
      "voiceGateError": "The audio could not be transcribed. Please try again.",
      "testReportExample": "Use the template {{template}} and add the block {{block}}"
    }
  },
  "voiceHelp": {
    "title": "Voice commands",
    "intro": "While recording you can use voice commands to edit the report. You can also simply dictate text and it will be inserted at the cursor position. Here are the available commands:",
    "deleteTitle": "Delete text",
    "deleteDesc": "Removes text from the report. You can specify a particular section.",
    "deleteEx1": "Delete the patient presents pain",
    "deleteEx2": "Remove in the findings section the hepatic mass",
    "updateTitle": "Update text",
    "updateDesc": "Replaces one text with another. Use 'to' or 'with' to indicate the new value.",
    "updateEx1": "Change patient to individual",
    "updateEx2": "Replace in the technique section FLAIR sequence with T2 sequence",
    "insertTitle": "Insert text",
    "insertDesc": "Adds new text to the report. You can specify a section or a relative position (before/after).",
    "insertEx1": "Insert the patient presents good general condition",
    "insertEx2": "Add in the findings section mass of 3 cm",
    "insertEx3": "Insert in the technique section with T1 sequences after knee MRI",
    "insertEx4": "Add this content before findings",
    "insertSectionTitle": "Insert section",
    "insertSectionDesc": "Creates a new section in the report. You can indicate the position relative to another section.",
    "insertSectionEx1": "Insert a new technique section",
    "insertSectionEx2": "Add section notes before the conclusion",
    "selectTitle": "Select options",
    "selectDesc": "When the system shows numbered options, you can select, change or delete specific options by number.",
    "selectEx1": "Select one and two",
    "selectEx2": "Choose from 1 to 4",
    "selectEx3": "Change the first one",
    "selectEx4": "Delete number 4",
    "selectEx5": "Change all",
    "generateTitle": "Generate report",
    "generateDesc": "Generates or regenerates the complete report.",
    "generateEx1": "Generate report",
    "dictationTitle": "Dictation and punctuation",
    "dictationDesc": "You can dictate punctuation marks and formatting with your voice.",
    "dictationEx1": "period → .",
    "dictationEx2": "comma → ,",
    "dictationEx3": "colon → :",
    "dictationEx4": "new line → line break",
    "dictationEx5": "new paragraph → paragraph break",
    "tip": "💡 Commands work with optional prefixes like the assistant name (Carolina), polite expressions (please) or casual greetings (hey). They also tolerate punctuation generated by speech recognition."
  },
  "batch": {
    "title": "Batch dictation",
    "uploadSubtitle": "Upload an audio file with multiple reports",
    "transcribingSubtitle": "Transcribing audio...",
    "reviewSubtitle": "Review and correct the detected studies",
    "generatingSubtitle": "Generating reports...",
    "stepUpload": "Upload audio",
    "stepReview": "Review",
    "transcriptionComplete": "Transcription completed — {{count}} studies detected",
    "transcriptionError": "Error transcribing the audio",
    "noStudies": "No studies found. Make sure to use the [Patient ID] format.",
    "batchSaved": "Batch saved successfully — {{count}} studies",
    "saveError": "Error saving the batch",
    "invalidFormat": "Unsupported format. Use .wav, .mp3, .ogg or .webm files",
    "durationExceeded": "Total audio duration cannot exceed 30 minutes",
    "transcribingAudio": "Transcribing audio...",
    "transcribingHint": "The audio is being processed. This may take a few seconds.",
    "dropHere": "Drop the file here",
    "uploadTitle": "Upload your audio file",
    "uploadHint": "Drag a file here or click to select",
    "supportedFormats": "Supported formats: .wav, .mp3, .ogg, .webm",
    "useMockData": "Use sample data",
    "processAudio": "Process audio",
    "pause": "Pause",
    "playAll": "Play all",
    "unifiedHint": "Each study is separated by [Patient ID]. Press ▶ next to each patient to listen to their audio segment.",
    "studiesDetected": "{{count}} studies detected",
    "scrollToBottom": "Go to bottom",
    "goToEnd": "Go to end",
    "saving": "Saving batch...",
    "playSegment": "Play segment",
    "unifiedPlaceholder": "[Patient 12345678]\nStudy description...\n\n[Patient 87654321]\nAnother study...",
    "generateAll": "Generate all"
  },
  "voiceCommands": {
    "noTextToDelete": "No text to delete was specified",
    "editorNotAvailable": "Editor not available",
    "completeUpdatesBeforeDelete": "Complete or cancel pending updates before making deletions",
    "textNotFound": "\"{{text}}\" not found",
    "textNotFoundInDocument": "\"{{text}}\" not found in the document",
    "couldNotDeleteText": "Could not delete the text",
    "noPendingOperations": "No pending operations. Use the DELETE, UPDATE or INSERT command first.",
    "noMatchesFound": "No marked matches found",
    "noIndicesSpecified": "No indices specified",
    "invalidIndices": "Invalid indices: {{indices}}. Valid range: 1-{{max}}",
    "noMatchesForIndices": "No matches found for the specified indices",
    "noMatchesForIndicesDetail": "No matches found for the specified indices: {{indices}}",
    "noTextToUpdate": "No text to update was specified",
    "noReplacementText": "No replacement text was specified",
    "completeDeletesBeforeUpdate": "Complete or cancel pending deletions before making updates",
    "couldNotUpdateText": "Could not update the text",
    "updateExtensionNotAvailable": "The update extension is not available",
    "noMarkedElements": "No marked elements found in the document",
    "noPendingOperationsSimple": "No pending operations",
    "couldNotFindInsertPosition": "Could not find the insertion position",
    "noContentToInsert": "No content to insert",
    "noReferenceText": "No reference text was specified",
    "completeDeletesBeforeInsert": "Complete or cancel pending deletions before making insertions",
    "completeUpdatesBeforeInsert": "Complete or cancel pending updates before making insertions",
    "insertExtensionNotAvailable": "The insertion extension is not available",
    "couldNotGenerateReport": "Could not generate the report",
    "textInsertedInReport": "Text inserted in the report",
    "textInsertedInDescription": "Text inserted in the description",
    "textInsertedAtEndOfReport": "Text inserted at the end of the report",
    "textUpdated": "Text updated",
    "textDeleted": "Text deleted",
    "matchesFoundClickToUpdate": "{{count}} matches found. Click on the underlined text to update it.",
    "matchesFoundUseSelect": "{{count}} matches found. Use 'select' to choose which ones to delete.",
    "matchesDeleted": "{{count}} match(es) deleted",
    "matchesUpdated": "{{count}} match(es) updated",
    "couldNotProcessDeletions": "Could not process the deletions",
    "couldNotProcessUpdates": "Could not process the updates",
    "generateReportOnlyFromDescription": "The generate report command only works from the description or with indices",
    "generatingReport": "Generating report...",
    "voiceInputProcessingError": "Error processing voice input",
    "deleteExtensionNotAvailable": "The deletion extension is not available",
    "textNotFoundInValidSection": "\"{{text}}\" not found within a valid section",
    "textNotFoundForInsert": "\"{{text}}\" not found for insertion",
    "noSectionSpecified": "No section was specified",
    "sectionNotFound": "Section \"{{section}}\" not found",
    "textNotFoundInSection": "\"{{text}}\" not found in section \"{{section}}\"",
    "sectionTitleRequired": "A title is required for the section",
    "referenceSectionRequired": "A reference section must be specified",
    "cannotAddSection": "Cannot add the section",
    "couldNotInsertSection": "Could not insert the section",
    "errorInsertingSection": "Error inserting the section",
    "couldNotDetermineInsertPosition": "Could not determine the insertion position in \"{{section}}\"",
    "errorInsertingTextInSection": "Error inserting text in the section",
    "noCommandRecognized": "No command recognized"
  },
  "share": {
    "me": "Me",
    "sharedWith": "Shared with",
    "title": "Share draft",
    "tabUsers": "People",
    "tabLink": "Link",
    "searchUser": "Search by name or email...",
    "userAdded": "User added successfully",
    "cannotShareSelf": "You cannot share with yourself",
    "differentAccount": "You can only share with users from your account",
    "errorSharing": "Error sharing",
    "userRemoved": "Access revoked",
    "errorRemoving": "Error revoking access",
    "errorUpdating": "Error updating permissions",
    "linkEnabled": "Link enabled",
    "errorLink": "Error updating link",
    "linkCopied": "Link copied to clipboard",
    "errorCopyLink": "Error copying link",
    "tokenRegenerated": "Link regenerated",
    "errorRegenerate": "Error regenerating link",
    "owner": "Owner",
    "addedBy": "Added by",
    "permView": "View",
    "permEdit": "Edit",
    "targetNotFound": "User to share with not found",
    "linkInvalid": "Invalid or disabled link",
    "linkOtherAccount": "This link belongs to another account and cannot be opened",
    "joinError": "Error accessing the shared draft",
    "goToReports": "Go to reports",
    "joining": "Opening the shared draft...",
    "noUsersFound": "No users found",
    "noUsersShared": "Not shared with anyone yet",
    "shareLinkTitle": "Share by link",
    "shareLinkDesc": "Anyone with the link can access",
    "linkPermission": "Link permission",
    "removeAccess": "Revoke access",
    "addUser": "Share",
    "copy": "Copy",
    "copyLink": "Copy link",
    "errorUpdatingLink": "Error updating the link"
  },
  "collaboration": {
    "connected": "Live",
    "connecting": "Connecting...",
    "invite": "Invite",
    "inviteMore": "Invite more people"
  },
  "workHistory": {
    "title": "Work history",
    "subtitle": "Work history",
    "sent": "Sent",
    "drafts": "Drafts",
    "empty": "No reports in this section.",
    "error": "Could not load the history."
  },
  "groupReports": {
    "exportFileName": "work_history",
    "titlePrefix": "Work ",
    "titleAccent": "history",
    "subtitle": "Sent reports and drafts from the members of your group.",
    "subtitleAccount": "Sent reports and drafts from the members of the account.",
    "subtitleSelf": "Your sent reports and drafts.",
    "kind": "Report type",
    "sent": "Sent",
    "drafts": "Drafts",
    "author": "Author",
    "allAuthors": "Whole group",
    "scope": "Scope",
    "scopeAccount": "Whole account",
    "scopeSearch": "Search group or person…",
    "scopeExpand": "Show group members",
    "scopeNoMatches": "No matches.",
    "scopeEmptyGroup": "Group has no users.",
    "search": "Search",
    "searchPlaceholder": "Search by title…",
    "from": "From",
    "to": "To",
    "clearFilters": "Clear filters",
    "count": "{{count}} results",
    "searchModality": "Modality…",
    "searchRegion": "Region…",
    "modalities": "Modalities",
    "regions": "Regions",
    "allTags": "Show all tags",
    "exportReports": "Download reports",
    "exportPreviewTitle": "Download reports",
    "exportPreviewSubtitle": "Preview of the Excel file to be downloaded.",
    "exportSheetName": "work_history",
    "exportRowCount": "{{count}} rows",
    "exportMoreRows": "+ {{count}} more rows in the export",
    "exportCol_title": "Title",
    "exportCol_author": "Author",
    "exportCol_group": "Group",
    "exportCol_date": "Date",
    "exportCol_modality": "Modality",
    "exportCol_region": "Region",
    "exportDownload": "Download Excel",
    "exportError": "Could not load the reports to export.",
    "exportErrorDownload": "Could not generate the Excel file.",
    "processingLabel": "{{count}} report(s) processing",
    "processingTooltip": "{{count}} report(s) are being processed. The list will refresh automatically when they finish.",
    "untitled": "Untitled",
    "noMatches": "No report matches the filters.",
    "empty": "There are no reports in your group yet.",
    "emptySelf": "You don't have any reports yet.",
    "error": "Could not load the group reports.",
    "errorSelf": "Could not load your reports."
  },
  "radiologistInsights": {
    "periodCustom": "Custom period",
    "title": "Your metrics",
    "subtitle": "{{name}}'s activity",
    "groupFallbackName": "group",
    "scopeLabel": "Statistics scope",
    "scopePersonal": "Personal area",
    "scopeGroup": "Group area",
    "groupPlaceholderTitle": "Group statistics",
    "groupPlaceholderText": "Aggregated group statistics will be available soon.",
    "correlationTitle": "Radiologists' joint activity",
    "correlationSubtitle": "Joint activity relative to the group's most active radiologist (0–1)",
    "correlationPairCount": "{{count}} comparisons",
    "correlationPairOne": "1 comparison",
    "correlationNoPairs": "At least two radiologists are needed to compare their activity.",
    "correlationError": "Could not load the group's radiologists.",
    "correlationEmpty": "There are no radiologists in the group.",
    "groupError": "Could not load the group statistics.",
    "groupOverviewSection": "Group overview",
    "groupRadiologistsSection": "Radiologists",
    "groupProductionTitle": "Group production",
    "groupProductionSubtitle": "{{total}} reports in the selected period",
    "groupModalityTitle": "Reports by modality",
    "groupModalitySubtitle": "Group distribution",
    "topRadiologistsTitle": "Most productive radiologists",
    "topRadiologistsSubtitle": "Reports produced per radiologist",
    "timePerRadiologistTitle": "Average time per radiologist",
    "timePerRadiologistSubtitle": "Editing minutes per report",
    "snomedTooltip": "All findings are standardized using the international SNOMED CT code",
    "processingLabel": "{{count}} report(s) processing",
    "processingTooltip": "{{count}} report(s) are still being processed. The charts will refresh automatically once finished.",
    "periodMonth": "This month",
    "periodWeek": "Last week",
    "periodLast30": "Last 30 days",
    "periodDay": "Today",
    "kpi": {
      "reportsMonth": "Reports this month",
      "reportsRange": "Reports in the period",
      "vsPrevRange": "vs previous period",
      "reportsWeek": "Reports this week",
      "reportsDay": "Reports today",
      "reportsLast30": "Reports last 30d",
      "vsLastMonth": "vs last month",
      "vsLastWeek": "vs last week",
      "vsYesterday": "vs yesterday",
      "vsPrev30": "vs previous 30 days",
      "topModality": "Your top modality",
      "topRegion": "Your top region",
      "reportsCount": "{{count}} reports",
      "percentOfTotal": "{{percent}}% of total",
      "findingsPerReport": "Findings per report",
      "billing": "Billing",
      "accumulated": "Monthly accumulated",
      "topRadiologist": "Radiologist with most reports",
      "groupTotalReports": "Group reports",
      "thisMonth": "this month",
      "activeRadiologists": "Active radiologists",
      "inTheGroup": "in the group",
      "groupAvgEditTime": "Average edit time",
      "perReport": "per report"
    },
    "reportsPerDay": "Reports per day",
    "dailyAverage": "Your daily average: {{average}} reports",
    "reports": "reports",
    "dayLabel": "Day {{day}}",
    "today": "today",
    "average": "avg",
    "modalities": "Your modalities",
    "periodDistribution": "Period distribution",
    "noData": "No data",
    "frequentFindings": "Most frequent findings",
    "seeAll": "See all →",
    "inYourReports": "In your reports · {{total}} total mentions",
    "findingsBy": "Findings by",
    "searchModality": "Search modality...",
    "searchRegion": "Search region...",
    "noFindingsForFilters": "No findings for these filters in the period.",
    "filter": "Filter:",
    "yourReportsCount": "{{count}} of your reports",
    "billing": "Your billing",
    "billingMeta": "{{range}} · <strong>{{accumulated}}</strong> accumulated · end-of-month projection {{projection}}",
    "billingMetaWeek": "{{range}} · <strong>{{accumulated}}</strong> accumulated · end-of-week projection {{projection}}",
    "billingMetaDay": "{{range}} · <strong>{{accumulated}}</strong> accumulated today",
    "billingMetaLast30": "{{range}} · <strong>{{accumulated}}</strong> accumulated in the last 30 days",
    "billingDaily": "Daily revenue",
    "billingDailySubtitle": "What you billed each day of the period",
    "editTimeSection": "Edit time",
    "reportsSection": "Reports",
    "findingsSection": "Findings",
    "billingSection": "Billing",
    "editTimeAvgCard": "Average time per report",
    "editTimeCardSub": "{{reports}} reports · {{total}} total",
    "editTimeEmpty": "No edit data for this period",
    "editTimeMedianCard": "Median per report",
    "editTimeMedianSub": "Central value of {{reports}} reports",
    "editTimeLastCard": "Last report",
    "editTimeLastSub": "Time of the most recent report",
    "editTime": "Time dedicated per day",
    "editTimeAvg": "Average per report: {{average}} · Total: {{total}} in {{reports}} reports",
    "editTimeLabel": "time",
    "presave": {
      "sectionTitle": "Inconsistencies and warnings",
      "overrideRate": "Forced send rate",
      "overrideTrendTooltip": "Change vs previous period (percentage points)",
      "overrideSub": "{{count}} decisions",
      "totalWarnings": "Group warnings",
      "totalSub": "{{forced}} sent anyway",
      "warningsPerReport": "Inconsistencies per report",
      "perReport": "density",
      "topOverride": "Highest forced send rate",
      "topOverrideSub": "{{pct}}% · {{forced}} sent anyway",
      "timelineTitle": "Inconsistencies per day",
      "timelineSubtitle": "Daily split between Review (green) and Send anyway (red)",
      "splitTitle": "Decision split",
      "splitSubtitle": "Share of forced sends over total decided",
      "radiologistsTitle": "Unresolved inconsistency rate per radiologist",
      "radiologistsSubtitle": "% of warnings sent anyway over the total decided",
      "radiologistsVolumeTitle": "Radiologists with most inconsistencies",
      "radiologistsVolumeSubtitle": "Total warnings issued by each group radiologist",
      "templatesTitle": "Templates with most warnings",
      "templatesSubtitle": "Procedures where the inconsistency originates",
      "listTitle": "Inconsistency events",
      "listMeta": "{{total}} warnings",
      "colDate": "Date",
      "colRadiologist": "Radiologist",
      "colJustification": "Justification",
      "colDecision": "Decision",
      "review": "Review",
      "forceSend": "Send anyway",
      "pending": "Pending",
      "override": "Forced",
      "empty": "No warnings in the selected period.",
      "loadMore": "Load more ({{remaining}} remaining)",
      "collapse": "Collapse"
    }
  },
  "voice": {
    "recoveryTitle": "Unprocessed recording",
    "recoveryDescription": "Your recording could not be processed after several attempts. You can retry or discard the recording.",
    "recoveryRetry": "Retry",
    "recoveryDownload": "Download audio",
    "recoveryDiscard": "Discard",
    "recoveryConfirmDiscard": "Are you sure? Click again",
    "hardLimitReached": "Maximum recording limit reached (1h 30m). Audio is being processed.",
    "importBusy": "Finish or cancel the current dictation before importing audio.",
    "importMultipleFiles": "Drop a single audio file.",
    "importUnsupportedType": "Only audio files are supported.",
    "importTooLarge": "The file exceeds the {{maxMb}} MB limit.",
    "importTooLong": "The audio exceeds the {{maxMin}}-minute limit.",
    "importDecodeFailed": "The audio could not be read. Try another format.",
    "importNoVoice": "No speech was detected in the imported audio.",
    "importNoEncoder": "This browser cannot prepare imported audio. Update it or use another browser.",
    "importError": "The imported audio could not be prepared.",
    "importComposeFailed": "The audio could not be merged. Dictation is still paused: send it again.",
    "importPreparing": "Preparing audio…",
    "importDropHint": "Drop the audio to load it",
    "softLimitWarning": "Recording has been going for over 10 minutes",
    "errorTimeout": "The server took too long. Your audio is saved, you can retry.",
    "errorDisconnected": "Connection to the server was lost. Your audio is saved.",
    "generationInProgress": "A generation is already in progress. Please wait for it to finish.",
    "errorAfterApplied": "Generation finished with an error. Review the content applied to the report.",
    "dictationNoAccess": "You don't have access to this draft.",
    "dictationTooLarge": "The audio exceeds the maximum size for dictation.",
    "errorGeneration": "Error generating the report. Your audio is saved, you can retry.",
    "errorGeneric": "Error processing audio. Your audio is saved.",
    "audioSaved": "Audio received",
    "templateNotFound": "Template \"{{templateName}}\" not found.",
    "processingDictation": "Processing dictation…",
    "holdCancel": "Cancel",
    "holdLock": "Lock",
    "holdSend": "Send",
    "traditionalDictation": "Traditional dictation",
    "holdRightClickHint": "Hold to dictate"
  },
  "micPage": {
    "title": "Phone microphone",
    "connecting": "Connecting…",
    "needPermission": "You must allow microphone access on your phone before recording. Tap to allow it.",
    "allowMic": "Allow microphone",
    "retryMic": "Retry microphone permission",
    "permissionBlocked": "Microphone access was denied. Enable it in your phone browser settings and tap again.",
    "micNotFound": "No microphone was detected on this phone.",
    "micBusy": "Another app is using the microphone. Close it and try again.",
    "micUnavailable": "Could not access the phone microphone. Tap again to retry.",
    "ready": "Ready. Tap the button to record.",
    "waitingDesktop": "Waiting for the desktop…",
    "recording": "Recording…",
    "paused": "Paused",
    "processing": "Processing audio…",
    "processingHint": "Silero is trimming silences…",
    "record": "Record",
    "pause": "Pause",
    "resume": "Resume",
    "stop": "Send",
    "cancel": "Cancel",
    "desktopConnected": "Desktop connected",
    "desktopWaiting": "Desktop not connected",
    "desktopBusy": "The desktop is recording. Wait until it finishes.",
    "missingToken": "The pairing link is missing. Scan the QR code again.",
    "invalidToken": "This link is not valid. Generate another code on the desktop.",
    "expiredToken": "The code has expired. Generate another one on the desktop.",
    "roomFull": "A phone is already connected to this code.",
    "permissionDenied": "Could not access the microphone. Check the browser permission.",
    "insecureOrigin": "The microphone needs HTTPS (or localhost).",
    "disconnected": "Lost connection with the desktop.",
    "helloTimeout": "Could not join the room. Please try again.",
    "idle": "The room closed due to inactivity.",
    "recordingLimit": "The recording limit was reached.",
    "relayError": "Could not connect. Generate another code on the desktop."
  },
  "orgAdmin": {
    "backToApp": "Back to Ainovis",
    "loadError": "Could not load this information.",
    "saveError": "Could not save. Check the data and try again.",
    "comingSoon": "Coming soon",
    "shell": {
      "eyebrow": "Administration",
      "pageTitlePrefix": "Administration ",
      "pageTitleAccent": "panel",
      "pageSubtitle": "Manage the whole {{name}} account",
      "meta": "{{groups}} groups · {{users}} users"
    },
    "rail": {
      "title": "Account",
      "groups": "Groups",
      "account": "Whole account",
      "accountPicker": "Account",
      "emptyAccount": "No groups yet. Add the first one",
      "usersTooltip": "Users in the group"
    },
    "confirm": {
      "deleteGroupHint": "Its users will be left without an assigned group. This cannot be undone.",
      "irreversible": "This action cannot be undone."
    },
    "nav": {
      "overview": "Overview",
      "stats": "Statistics",
      "groups": "Groups",
      "users": "Users",
      "templates": "Templates",
      "settings": "Permissions"
    },
    "period": {
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "last30": "Last 30 days"
    },
    "overview": {
      "title": "Overview",
      "subtitle": "{{name}} activity",
      "reports": "Reports",
      "activeUsers": "Active users",
      "avgEdit": "Average edit time",
      "topUser": "Top user",
      "reportsCount": "{{count}} reports",
      "activity": "Activity",
      "contact": "Contact details",
      "noContact": "No contact details.",
      "parent": "Account",
      "shortcuts": "Go to",
      "groupsTitle": "Groups",
      "topGroup": "Busiest group",
      "fastestGroup": "Fastest group"
    },
    "groups": {
      "title": "Groups",
      "subtitle": "Groups in the account",
      "addGroup": "Add group",
      "emptyGroups": "This account has no groups yet.",
      "usersCount": "{{active}}/{{count}} users",
      "deleteGroupConfirm": "Delete group {{name}}?",
      "editGroup": "Edit group"
    },
    "form": {
      "name": "Name",
      "surname": "Surname",
      "nationalId": "Tax ID",
      "nameRequired": "Name is required.",
      "address": "Address",
      "professionalTitle": "Professional title (optional)",
      "email": "Email",
      "phone": "Phone",
      "namePlaceholder": "E.g. Mary",
      "surnamePlaceholder": "E.g. Smith Johnson",
      "emailPlaceholder": "E.g. mary@hospital.com",
      "nationalIdPlaceholder": "E.g. 12345678A",
      "addressPlaceholder": "E.g. 1 Main Street, Madrid",
      "professionalTitlePlaceholder": "Dr., Dr. (f.), ...",
      "phonePlaceholder": "E.g. +34 912 345 678"
    },
    "users": {
      "title": "Users",
      "searchPlaceholder": "Search by name or email",
      "allRoles": "All roles",
      "allStatuses": "All statuses",
      "filters": "Filters",
      "columnUser": "User",
      "columnRole": "Role",
      "columnGroup": "Group",
      "columnStatus": "Status",
      "statusActive": "Active",
      "statusPending": "Pending",
      "statusInactive": "Inactive",
      "noGroup": "No group",
      "count": "{{count}} users",
      "empty": "This account has no users yet.",
      "emptyFiltered": "No user matches the filters.",
      "selected": "{{count}} selected",
      "selectAll": "Select all",
      "bulkLabel": "Personal templates:",
      "bulkDone": "{{count}} users updated.",
      "bulkPartial": "{{count}} users could not be updated.",
      "columnActions": "Actions",
      "add": "Add user",
      "addHint": "They will get an email to verify the account and set a password.",
      "sendInvite": "Create and invite",
      "createOnly": "Create without inviting",
      "edit": "Edit user",
      "editHint": "Role and group are changed from the table.",
      "emailLocked": "The sign-in email cannot be changed.",
      "updated": "User updated.",
      "formRequired": "Fill in all required fields.",
      "resend": "Resend invitation",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "activated": "User activated.",
      "deactivated": "User deactivated.",
      "roleChanged": "Role updated.",
      "groupChanged": "User moved to another group.",
      "inviteSent": "Invitation sent.",
      "deleted": "User deleted.",
      "deleteTitle": "Delete {{name}}?",
      "deleteHint": "Their drafts, templates and settings are deleted too.",
      "loadMore": "Load more ({{remaining}} remaining)",
      "endOfList": "No more users.",
      "page": "Page {{page}} of {{totalPages}}",
      "loadError": "Users could not be loaded.",
      "accessTitle": "Access and permissions",
      "accessSelfHint": "You cannot change your own role or permissions."
    },
    "templates": {
      "title": "Templates",
      "total": "{{count}} templates",
      "upload": "Upload",
      "uploadScope": "Scope",
      "uploadScopePlaceholder": "Choose a scope…",
      "scopeEverything": "Account and groups",
      "scopeAll": "{{name}}",
      "scopeOnlyAccount": "Account only",
      "hintAll": "{{total}} templates across {{count}} groups",
      "hintAccount": "Visible to all {{count}} groups in the {{name}} account · {{total}} templates",
      "hintGroup": "Visible only to the {{name}} team · {{total}} templates",
      "searchPlaceholder": "Search template",
      "selected": "{{count}} selected",
      "moveTo": "Move to",
      "edit": "Edit template",
      "select": "Select {{name}}",
      "page": "Page {{page}} of {{totalPages}}",
      "emptyAccount": "This account has no institutional templates yet.",
      "emptyGroup": "This group has no templates of its own.",
      "emptyGroupHint": "It also sees the {{count}} shared by the {{name}} account.",
      "emptyFiltered": "No template matches the search.",
      "confirmDelete": "Delete {{count}} templates? This cannot be undone.",
      "confirmPromote": "You are about to make {{count}} templates visible to all {{groups}} groups in the {{name}} account.",
      "loadError": "Templates could not be loaded.",
      "moveError": "Templates could not be moved.",
      "languageError": "The template language could not be changed.",
      "deleteError": "Templates could not be deleted.",
      "processing": "Saving",
      "processingHint": "This template has been saved. It is still being prepared for dictation and cannot be detected automatically until it is ready."
    },
    "scope": {
      "account": "Whole account",
      "group": "Group"
    },
    "settings": {
      "title": "Settings",
      "applyNote": "Overwrites the policy of the {{count}} existing groups with the values above."
    },
    "policy": {
      "title": "Template policy",
      "groupNote": "Applies to users of this group without custom permissions.",
      "personalTitle": "Personal templates",
      "personalHint": "Lets radiologists use, create and edit their own templates and blocks. Turning it off also hides the personal templates they already had.",
      "ainovisTitle": "Ainovis templates",
      "ainovisHint": "Allows access to Ainovis templates. When off, they are no longer available in the app.",
      "institutionalTitle": "Institutional templates",
      "institutionalHint": "Allows access to the group's and the account's templates. When off, they are no longer available in the app.",
      "allowed": "Allowed",
      "blocked": "Blocked",
      "inherit": "Inherited from group ({{state}})",
      "inheritShort": "Inherited from group",
      "groupPolicy": "Inherited from group",
      "legend": "Allowed / Blocked / Inherited from group: what each value means.",
      "legendAllowed": "this person can always use it, even if their group forbids it.",
      "legendBlocked": "this person can never use it, even if their group allows it.",
      "legendGroup": "this person has no setting of their own; their group's decision applies (shown next to it).",
      "legendNoGroup": "this person has no assigned group; the account default policy applies.",
      "alwaysAllowed": "Always allowed",
      "exemptHint": "Admins can always create templates.",
      "saved": "Policy updated.",
      "defaultsTitle": "Template permissions",
      "defaultsWarning": "These permissions apply to new groups. Existing groups are not changed.",
      "applyToGroups": "Apply permissions to existing groups",
      "applyConfirm": "This will overwrite the policy of every group in the account. Continue?",
      "applied": "Applied to {{count}} groups."
    },
    "classifications": {
      "title": "Classification policy",
      "note": "Choose who can use classifications in this account and which scales are available.",
      "groupNote": "What applies to the users of this group, unless they have their own permission.",
      "defaultsWarning": "Starting values for new groups. Existing groups keep their own.",
      "userTitle": "Classifications",
      "userHint": "Lets this person use classifications, regardless of what their group allows.",
      "scalesTitle": "Available classifications",
      "scalesCount": "{{active}} of {{total}} enabled",
      "scalesUserTitle": "Choose one by one",
      "scalesUserHint": "Exceptions for this person; anything left untouched follows the group.",
      "audienceTitle": "Who can classify",
      "saved": "Classification policy updated.",
      "audience": {
        "nobody": "Nobody",
        "admins": "Admins only",
        "everyone": "Whole account"
      },
      "audienceDesc": {
        "nobody": "Nobody in the account can classify.",
        "admins": "Current behaviour: only admins can classify.",
        "everyone": "Any user in the account can classify."
      },
      "hints": {
        "FLEISCHNER": "Pulmonary nodule",
        "TI-RADS": "Thyroid",
        "PI-RADS": "Prostate",
        "BOSNIAK_2019": "Renal cyst",
        "GARDEN": "Hip fracture",
        "EATON_LITTLER": "Thumb base osteoarthritis",
        "SNYDER": "Rotator cuff (shoulder)",
        "HERBERT_FISCHER": "Scaphoid fracture (wrist)"
      }
    },
    "permissions": {
      "column": "Permissions",
      "edit": "Edit permissions",
      "title": "{{name}}'s permissions",
      "bulkTitle": "Permissions for {{count}} users",
      "bulkHint": "Changes apply to every selected user.",
      "inherited": "Inherited",
      "custom": "Custom",
      "mixed": "Mixed values",
      "partialExempt": "{{count}} of the selected users always have it allowed."
    },
    "group": {
      "back": "Back to groups",
      "title": "Group",
      "subtitle": "Group activity and team",
      "team": "Team",
      "emptyTeam": "This group has no users yet.",
      "active": "Active",
      "inactive": "Inactive"
    },
    "roles": {
      "user": "User",
      "admin": "Admin",
      "supervisor": "Supervisor",
      "super": "Super"
    }
  },
  "jobsIA": {
    "interrumpido": "AI generation was interrupted.",
    "reintentar": "Retry",
    "descartar": "Dismiss notice",
    "confirmarTitulo": "Retry generation?",
    "confirmarMensaje": "The draft was edited after the interruption. If you retry, it will go back to its state before the interrupted step and those changes will be lost.",
    "yaReintentado": "Someone else already retried this generation.",
    "ocupado": "The draft is busy with another generation. Try again in a few seconds.",
    "noReintentable": "This generation can no longer be retried.",
    "noDisponible": "The service is not available right now. Try again later.",
    "noEncontrado": "The generation was not found.",
    "errorRed": "Could not retry. Check your connection.",
    "procesando": "Processing"
  }
}
